import React, { useEffect, useState, useRef } from "react";
import { createPortal } from "react-dom";
import { useNavigate, useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import generateMC from "../../../../utils/generateMC";
import generatePC from "../../../../utils/generatePC";
import createBDFExcel from "../../../../utils/createBDFExcel";
import convertS3ToCloudFront, {
  getViewableFileUrl,
} from "../../../../utils/convertS3ToCloudFront";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import customParseFormat from "dayjs/plugin/customParseFormat";
import {
  Button,
  Tabs,
  Input,
  Select,
  DatePicker,
  Table,
  notification,
  Checkbox,
  Modal,
  AutoComplete,
  Form,
  Tooltip,
  InputNumber,
  Alert,
  Switch,
  Spin,
} from "antd";
import discountCalc from "../../../../utils/discountCalc";
import {
  COMPANY_CATEGORIES,
  isValidCompanyCategory,
} from "../../../../utils/companyCategories";
import CustomInputComponent from "../../components/CustomInputComponent";
import DynamicInputComponent from "../../components/DynamicInputComponent";
import { act } from "react-dom/test-utils";
import { useDispatch, useSelector } from "react-redux";
import {
  emptyDraft,
  getInventories,
  saveDraft,
} from "../../../toolkit/slices/inventories/inventorySlice";
import filterSearch from "../../../../utils/filterSearch";
import {
  getBdfLineKey,
  withBdfLineKey,
  ensureUniqueBdfLineKeys,
  enrichBdfInventoryFromRedux,
  hasOverlapWithSiblingBdfLines,
  isDateBlockedBySiblingBdfLines,
  normalizeBdfInventoriesFromApi,
} from "../../../../utils/bdfLineKey";
import BdfExcelImportModal from "../../components/BdfExcelImportModal";
import useBdfExcelImport from "../BDFCreatorContainer/useBdfExcelImport";
import TradingExcelImportModal from "../../components/TradingExcelImportModal";
import useTradingExcelImport from "../BDFCreatorContainer/useTradingExcelImport";
import moment from "moment";
import AddSuffixModal from "../../components/AddSuffixModal";
import { useLocation } from "react-router-dom";
import { PlusOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { Row, Col } from "antd";
import Trade from "../InventoryContainer/Trade";
import "../InventoryContainer/InventoryContainer.css";

dayjs.extend(utc);
dayjs.extend(customParseFormat);

const { Option } = Select;
const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
const BDFEditorContainer = () => {
  const [editedRows, setEditedRows] = useState({});
  const [activeTabInner, setActiveTabInner] = useState("");
  const { inventories: dataInv, bdfData: dataBdf } = useSelector(
    (state) => state.inventoriesList.draft,
  );
  const [activeTab, setActiveTab] = useState("1"); // State to ke
  const [proposalInfo, setProposalInfo] = useState(null);
  const [partyChanged, setPartyChanged] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [inputLabel, setInputLabel] = useState("");
  const [bdfId, setBdfId] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const proposalInvs = useSelector(
    (state) => state.proposalList.proposalInventories,
  );
  const salesMan = useSelector((state) => state.user.name);
  const [inventories, setInventories] = useState(
    dataInv ? dataInv : proposalInvs.invs,
  );
  const [suffixInventories, setSuffixInventories] = useState([]);
  // Where the Excel upload buttons (rendered by the inventories tab) are shown, top right.
  const [excelActionsEl, setExcelActionsEl] = useState(null);
  const [optionsForBrands, setOptionsForBrands] = useState(null);
  const [dateArr, setDateArr] = useState(null);
  const [inputGSTValue, setInputGSTValue] = useState("");
  const [isPackageRateEnabled, setIsPackageRateEnabled] = useState(
    proposalInvs?.packageRate ? true : false,
  );
  const [packageRate, setPackageRate] = useState(
    proposalInvs?.packageRate || null,
  );
  const [showInnovationChargeColumn, setShowInnovationChargeColumn] =
    useState(false);
  const [segmentCategories, setSegmentCategories] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [companiesLoading, setCompaniesLoading] = useState(false);

  const [totalAmount, setTotalAmount] = useState(0);
  const [mountingCharge, setMountingCharge] = useState(0);
  const [printingCharge, setPrintingCharge] = useState(0);
  const [includePrintingCharge, setIncludePrintingCharge] = useState(true);
  const [includeMountingCharge, setIncludeMountingCharge] = useState(true);
  const [printingCost, setPrintingCost] = useState(0);
  const [mountingCost, setMountingCost] = useState(0);
  const [salesPersons, setSalesPersons] = useState([]);

  const [typeOfBDF, setTypeOfBDF] = useState("");

  const [bdfData, setBdfData] = useState(
    dataBdf
      ? dataBdf
      : {
        gstNumber: proposalInvs.GST,
        panNumber: null,
        bdfDate: moment().format("DD-MM-YYYY"),
        bdfNumber: null,
        salesPerson: "",
        salesPersonBaseLocation: "Ahmedabad",
        mediaPlannerName: salesMan,
        clientCategory: null,
        leadFrom: salesMan,
        ro: null,
        roFile: null,
        remark: null,
        parentCompanyName: proposalInvs?.clientName || null,
        parentCompanyId: proposalInvs?.clientId || null,
        brandName: null,
        brandId: null,
        billingPartyName: proposalInvs?.clientName || null,
        campaignName: proposalInvs?.campaignName || null,
        billingAddress: null,
        // brandCategory: null,
        brandSegment: null,
        // brandCategory: null,
        contactPerson: null,
        contactNumber: null,
        emailId: proposalInvs?.emailId || null,
        // modeOfPayment: null,
        creditPeriod: null,
        campaignDuration: null,
        clientId: proposalInvs?.clientId || null,
        packageRate: proposalInvs?.packageRate || null,
        getTypeOfBDF: activeTabInner,
        bdfType: null,
        gstPercentage: 0,
        cashPercentage: 0,
      },
  );

  useEffect(() => {
    const fetchSalesPersons = async () => {
      try {
        const token = window.localStorage.getItem("token");
        const params = new URLSearchParams();
        params.set("page", "1");
        params.set("limit", "500");
        const res = await fetch(
          `${apiBaseUrl}/inventoryManagement/listSalesPersons?${params.toString()}`,
          {
            method: "GET",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
              ...(token ? { authorization: `Token ${token}` } : {}),
            },
          },
        );
        const data = await res.json();
        if (data.success && Array.isArray(data.data)) {
          const options = data.data
            .map((sp) => String(sp.name || "").trim())
            .filter((name) => !!name)
            .map((name) => ({ value: name }));
          setSalesPersons(options);
        }
      } catch (error) {
        console.error("Error fetching sales persons:", error);
      }
    };

    fetchSalesPersons();
  }, []);

  // console.log("BDF DATA", bdfData);
  // console.log("proposalInvs:: ", proposalInvs);

  // useEffect(() => {
  //   if (proposalInvs.GST) {

  //     console.log("proposalInvs?.GST::", proposalInvs?.GST);
  //     fetchClientByGST(proposalInvs?.GST);
  //   }
  // }, []);

  const dispatch = useDispatch();
  const [bdfErrors, setBdfErrors] = useState({
    gstNumber: null,
    // bdfDate: null,
    // bdfNumber: null,
    salesPerson: null,
    // salesPersonBaseLocation: null,
    // mediaPlannerName: null,
    // clientCategory: null,
    // leadFrom: null,
    // ro: null,
    parentCompanyName: null,
    parentCompanyId: null,
    brandName: null,
    // brandId: null,
    // billingPartyName: null,
    campaignName: null,
    // billingAddress: null,
    // brandCategory: null,
    brandSegment: null,
    // brandCategory: null,
    contactPerson: null,
    contactNumber: null,
    emailId: null,
    // modeOfPayment: null,
    creditPeriod: null,
    // campaignDuration: null,
  });
  const [err, setErr] = useState(false);

  useEffect(() => {
    if (bdfData?.bdfType) {
      setActiveTabInner(bdfData?.bdfType);
    }
  }, [bdfData.bdfType]);

  // Fetch segment categories when component mounts
  useEffect(() => {
    const fetchSegmentCategories = async () => {
      try {
        const response = await fetch(
          `${apiBaseUrl}/inventoryManagement/getAllSegmentCategories`,
          {
            method: "GET",
            credentials: "include",
          },
        );
        const data = await response.json();
        if (data.success && Array.isArray(data.data)) {
          setSegmentCategories(data.data);
        }
      } catch (error) {
        console.error("Error fetching segment categories:", error);
      }
    };

    fetchSegmentCategories();
  }, []);

  // useEffect(() => {
  //   if (proposalInvs?.GST) {
  //     setBdfData(prev=>{
  //       return {
  //         ...prev,gstNumber:proposalInvs?.GST
  //       }
  //     })
  //     fetchClientByGST(proposalInvs?.GST)
  //   }
  //   async function fetchClientByGST(gst) {
  //     try {
  //       let response = await fetch(`${apiBaseUrl}/inventoryManagement/fetchClientByGST`, {
  //         method: "POST",
  //         credentials: 'include',
  //         headers: {
  //           'Content-Type': 'application/json'
  //         },
  //         body: JSON.stringify({ gstNumber: gst })
  //       })
  //       const responseData = await response.json();
  //       console.log("🏥🏥🏥", responseData.data)
  //       if (response.ok) {
  //         let info = {
  //           billingPartyName: responseData?.data?.name,
  //           billingAddress: responseData?.data?.address,
  //           // brandCategory: responseData?.data?.brandCategory,
  //           // brandName: responseData?.data?.brandName,
  //           // brandSegment: responseData?.data?.brandSegment,
  //           // contactNumber: responseData?.data?.contactNumber,
  //           // contactPerson: responseData?.data?.contactPerson,
  //           // emailId: responseData?.data?.emailId,
  //           parentCompanyName: responseData?.data?.name,
  //         };

  //         updateBDFData(info);
  //       }
  //       let options = responseData?.data?.brands.map(ele => {
  //         return {
  //           label: ele.brandName,
  //           value: ele._id,
  //           brandSegment: ele.brandSegment,
  //           brandCategory: ele.brandCategory,
  //           brandCategory: ele.brandCategory
  //         }
  //       })
  //       setOptionsForBrands(options);

  //     } catch (err) {
  //       console.error(`Error: ${err.message}`)
  //     }
  //   }
  // }, [proposalInvs])

  useEffect(() => {
    if (
      activeTabInner == "B" ||
      activeTabInner == "C" ||
      activeTabInner == "F"
    ) {
      setBdfErrors((prev) => ({
        ...prev,
        gstNumber: null,
      }));
    } else {
      if (inputGSTValue || bdfData?.gstNumber) {
        handleErrors("gstNumber", inputGSTValue || bdfData?.gstNumber);
      } else {
        handleErrors("gstNumber", activeTabInner);
      }
    }
  }, [activeTabInner, bdfData]);
  async function fetchClientByGST(gst, partyName) {
    // console.log("gst::", gst);
    try {
      let response = await fetch(
        `${apiBaseUrl}/inventoryManagement/fetchClientByGST`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            gstNumber: gst,
            partyName: partyName ?? null,
          }),
        },
      );
      const responseData = await response.json();
      if (response.ok) {
        const category = responseData?.data?.category;
        const validCategory = isValidCompanyCategory(category)
          ? category
          : undefined;
        let info = {
          billingPartyName: responseData?.data?.name,
          billingAddress: responseData?.data?.address,
          // campaignName: responseData?.data?.name,
          // brandCategory: responseData?.data?.brandCategory,
          // brandName: responseData?.data?.brandName,
          // brandSegment: responseData?.data?.brandSegment,
          contactNumber: String(responseData?.data?.contactNumber),
          contactPerson: responseData?.data?.contactPerson,
          // emailId: responseData?.data?.email,
          parentCompanyName: responseData?.data?.name,
          parentCompanyId: responseData?.data?._id,
          ...(validCategory && { clientCategory: validCategory }),
        };

        updateBDFData(info);

        // Clear the error for the "Parent Company Name" field
        clearErrorForField("parentCompanyName");
      } else {
        let info = {
          billingPartyName: null,
          billingAddress: null,
          // brandCategory: responseData?.data?.brandCategory,
          // brandName: responseData?.data?.brandName,
          // brandSegment: responseData?.data?.brandSegment,
          // contactNumber: responseData?.data?.contactNumber,
          // contactPerson: responseData?.data?.contactPerson,
          // emailId: responseData?.data?.emailId,
          parentCompanyName: null,
          parentCompanyId: null,
          clientCategory: null,
        };

        updateBDFData(info);
      }
      let options = responseData?.data?.brands.map((ele) => {
        return {
          label: ele.brandName,
          value: ele._id,
          brandSegment: ele.brandSegment,
          // brandCategory: ele.brandCategory,
          // brandCategory: ele.brandCategory,
        };
      });
      setOptionsForBrands(options);
    } catch (err) {
      console.error(`Error: ${err.message}`);
    }
  }

  const clearErrorForField = (fieldName) => {
    setBdfErrors((prevErrors) => ({
      ...prevErrors,
      [fieldName]: "", // Clear the error for the specified field
    }));
  };

  function updateBDFData(info) {
    setBdfData((prev) => {
      return {
        ...prev,
        ...info,
      };
    });
  }

  const handleChange = (field, value, isBrandName) => {
    setBdfData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
    if (field === "parentCompanyName") {
      if (proposalInvs?.clientName) {
        if (proposalInvs?.clientName !== value) {
          setBdfData((prevData) => ({
            ...prevData,
            clientId: null,
          }));
          setPartyChanged(true);
          setOptionsForBrands([]);
        } else {
          setBdfData((prevData) => ({
            ...prevData,
            clientId: proposalInvs?.clientId,
          }));
          setPartyChanged(false);
        }
      }
    }
    if (isBrandName) {
      let ind = optionsForBrands.findIndex((ele) => ele.value === value);
      let data = optionsForBrands[ind];
      let info = {
        brandName: data?.label,
        brandSegment: data?.brandSegment,
        // brandCategory: data?.brandCategory,
      };
      setBdfData((prevData) => ({
        ...prevData,
        ...info,
      }));
    }
  };

  const handleErrors = (field, value) => {
    let hasError = false;
    setBdfErrors((prevErrors) => {
      const newErrors = { ...prevErrors };

      newErrors[field] = null;

      const gstNumberRegex =
        /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

      if (
        activeTabInner == "B" ||
        activeTabInner == "C" ||
        activeTabInner == "F"
      ) {
        console.log("No gst required");
      } else {
        if (field === "gstNumber") {
          if (!value || value.trim() === "") {
            newErrors[field] = "GST number is required";
            hasError = true;
          } else if (!gstNumberRegex.test(value.trim())) {
            newErrors[field] = "Invalid GST number format";
            hasError = true;
          }
        }
      }

      if (field === "parentCompanyName" && (value?.trim() === "" || !value)) {
        newErrors[field] = "Parent company name is required";
        hasError = true;
      }

      if (field === "brandName" && (value?.trim() === "" || !value)) {
        newErrors[field] = "Brand name is required";
        hasError = true;
      }
      if (field === "salesPerson" && (value?.trim() === "" || !value)) {
        newErrors[field] = "Sales Person Field is required";
        hasError = true;
      }

      if (field === "brandSegment" && (value?.trim() === "" || !value)) {
        newErrors[field] = "Brand Segment is required";
        hasError = true;
      }

      if (field === "campaignName" && (value?.trim() === "" || !value)) {
        newErrors[field] = "Campaign name is required";
        hasError = true;
      }

      // Validate contact person (string only)
      if (field === "contactPerson" && (value?.trim() === "" || !value)) {
        newErrors[field] = "Contact person is required";
        hasError = true;
      }

      // Validate contact number
      if (field === "contactNumber") {
        if (value?.trim().length !== 10 || isNaN(value) || !value) {
          newErrors[field] = "Contact number must be 10 digits";
          hasError = true;
        }
      }

      // Email validation
      if (field === "emailId") {
        if (!value) {
          newErrors[field] = "Email is required";
          hasError = true;
        } else if (!isValidEmail(value)) {
          newErrors[field] = "Invalid email format";
          hasError = true;
        }
      }

      // Validate mode of payment (string only)
      if (field === "modeOfPayment" && (value?.trim() === "" || !value)) {
        newErrors[field] = "Mode of payment is required";
        hasError = true;
      }

      // Validate credit period (number only and not empty)
      if (field === "creditPeriod") {
        if (value?.trim() === "" || !value) {
          newErrors[field] = "Credit period is required";
          hasError = true;
        } else if (isNaN(value) || !value) {
          newErrors[field] = "Credit period must be a number";
          hasError = true;
        }
      }

      return newErrors;
    });

    return hasError;
  };
  const handleErrorsSubmission = (field, value) => {
    let hasError = false;
    // Validate contact person (string only)

    if (field === "contactPerson" && (value?.trim() === "" || !value)) {
      hasError = true;
      // notification.error({message:"Fill Contact Person Details"})
    }

    if (field === "campaignName" && (value?.trim() === "" || !value)) {
      hasError = true;
    }

    // Validate contact number
    if (field === "contactNumber") {
      if (value?.trim().length !== 10 || isNaN(value) || !value) {
        hasError = true;
        // notification.error({message:"Fill in the Contact Number properly"})
      }
    }

    // Email validation
    if (field === "emailId") {
      if (!value) {
        hasError = true;
        // notification.error({message:"Fill in the Email ID"})
      } else if (!isValidEmail(value)) {
        hasError = true;
        // notification.error({message:"Fill in the Valid MAIL"})
      }
    }

    // Validate mode of payment (string only)
    if (field === "modeOfPayment" && (value?.trim() === "" || !value)) {
      hasError = true;
      // notification.error({message:"Must Choose the Mode Of Payment"})
    }

    // Validate credit period (number only and not empty)
    if (field === "creditPeriod") {
      if (value?.trim() === "" || !value) {
        hasError = true;
        // notification.error({message:"Fill in the Credit Period"})
      } else if (isNaN(value) || !value) {
        hasError = true;
        // notification.error({message:"Credit period must be a number"})
      }
    }
    return hasError;
  };

  // Regular expression for email validation
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const onChange = (key) => {
    setActiveTab(key);
  };
  async function fetchBDF(id) {
    let response = await fetch(
      `${apiBaseUrl}/inventoryManagement/getBdfDataById?id=${id}`,
      {
        method: "GET",
        credentials: "include",
      },
    );
    let responseJson = await response.json();
    return responseJson.data;
  }
  useEffect(() => {
    if (id !== "direct-bdf") {
      const fetchData = async () => {
        if (id) {
          let data = await fetchBDF(id);

          setTypeOfBDF(data?.bdfData?.bdfType);
          // setProposalInfo(data.data);
          setBdfData(data.bdfData);
          setInventories(normalizeBdfInventoriesFromApi(data.inventories));
          let suffixInvs = data?.bdfData?.suffixInventories.map((ele, ind) => {
            return {
              key: ind,
              suffixCode: ele?.suffixCode,
              suffixInfo: ele?.suffixInfo,
              specialRate: ele?.specialRate,
              vendor: ele?.vendor,
              startDate: ele?.startDate,
              endDate: ele?.endDate,
            };
          });
          setSuffixInventories(suffixInvs);
          setBdfId(id);
        }
      };
      fetchData();
    }
  }, [id]);

  // Fetch Parent Company options as soon as editor opens so parentCompanyId can be resolved at submit (even before Tab 1 is shown)
  useEffect(() => {
    const fetchCompanies = async () => {
      setCompaniesLoading(true);
      try {
        const response = await fetch(
          `${apiBaseUrl}/inventoryManagement/displayPartyCompanies`,
          {
            method: "GET",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
              authorization: `Token ${window.localStorage.getItem("token")}`,
            },
          },
        );
        const data = await response.json();
        if (data.success && Array.isArray(data.data)) {
          setCompanies(data.data);
        }
      } catch (error) {
        console.error("Error fetching company data", error);
      } finally {
        setCompaniesLoading(false);
      }
    };
    fetchCompanies();
  }, []);

  function sanitizeInventories(inventories) {
    return inventories.map((item) => {
      const keysToValidate = [
        "mountingCharge",
        "printingCharge",
        "specialRatePerMonth",
        "specialRate",
        "innovationRate",
      ];

      const {
        bdfLineKey,
        bdfInventoryLineId,
        inventoryId,
        excelDates,
        ...rest
      } = item;
      const sanitizedItem = { ...rest };

      keysToValidate.forEach((key) => {
        if (
          sanitizedItem[key] === undefined ||
          sanitizedItem[key] === null ||
          typeof sanitizedItem[key] !== "number"
        ) {
          sanitizedItem[key] = 0;
        }
      });

      // If package rate is enabled, use the internally stored actual charges
      if (packageRate !== null) {
        // Use the stored actual charges if they exist
        if (item._actualPrintingCharge !== undefined) {
          sanitizedItem.printingCharge = item._actualPrintingCharge;
        }

        if (item._actualMountingCharge !== undefined) {
          sanitizedItem.mountingCharge = item._actualMountingCharge;
        }
      }

      // ✅ Try DD-MM-YYYY first, fallback to auto parse
      const getValidUTCDate = (dateStr) => {
        if (!dateStr) return null;

        let parsed = dayjs.utc(dateStr, "DD-MM-YYYY", true);
        if (!parsed.isValid()) {
          parsed = dayjs.utc(dateStr); // fallback for ISO or other valid formats
        }

        return parsed.isValid() ? parsed.startOf("day").toISOString() : null;
      };

      sanitizedItem.startDate = getValidUTCDate(item.startDate);
      sanitizedItem.endDate = getValidUTCDate(item.endDate);

      return sanitizedItem;
    });
  }
  const areDatesProvided = () => {
    for (const ele of inventories) {
      if (!ele.startDate || !ele.endDate) {
        notification.error({ message: `${ele.location} dates are left empty` });
        return true;
      }
    }
    return false;
  };
  const handleBDFEdit = async () => {
    const queryParams = new URLSearchParams(location.search);
    const isOnHold = queryParams.get("type") === "onHold";

    let flag = false;
    let flagErr = false;

    Object.keys(bdfErrors).map((ele) => {
      console.log({ ele });
      handleErrors(ele, bdfData[ele]);
      console.log("ele", ele, bdfData[ele]);
      flagErr = handleErrorsSubmission(ele, bdfData[ele]);
    });

    const isGSTSelected = bdfData?.gstOrPan === "GST Number";
    const isPANSelected = bdfData?.gstOrPan === "PAN Number";

    if (
      (isPANSelected && (bdfErrors?.panNumber || !bdfData?.panNumber)) || // PAN validation
      (isGSTSelected &&
        activeTabInner != "F" &&
        (bdfErrors?.gstNumber || !bdfData?.gstNumber)) || // GST validation
      !bdfData?.parentCompanyName ||
      !bdfData?.brandName ||
      !bdfData?.brandSegment ||
      !bdfData?.campaignName ||
      !bdfData?.contactPerson ||
      !bdfData?.contactNumber ||
      bdfErrors?.contactNumber != null ||
      !bdfData?.emailId ||
      // !bdfData?.modeOfPayment ||
      bdfErrors?.emailId != null ||
      !bdfData?.creditPeriod ||
      bdfErrors.salesPerson ||
      !bdfData?.salesPerson
    ) {
      notification.error({
        message: `${!bdfData?.parentCompanyName ? "Parent company name is required, " : ""
          }${!bdfData?.brandName ? "Brand name is required, " : ""}${!bdfData?.brandSegment ? "Brand segment is required, " : ""
          }${!bdfData?.campaignName ? "Campaign name is required, " : ""}${!bdfData?.contactPerson ? "Contact person is required, " : ""}${!bdfData?.contactNumber
            ? "Contact number is required, "
            : bdfErrors?.contactNumber == "Contact number must be 10 digits"
              ? "Invalid Contact Number, "
              : ""
          }${!bdfData?.emailId
            ? "Email id is required, "
            : bdfErrors?.emailId == "Invalid email format "
              ? "Invalid Email, "
              : ""
          }${!bdfData?.creditPeriod ? "Credit period is required, " : ""}${!bdfData?.modeOfPayment && activeTabInner != "F"
            ? "Mode of Payment is required"
            : ""
          }${!bdfData?.approvedBy && activeTabInner != "F"
            ? "Approved by is required ,"
            : ""
          }${bdfErrors?.salesPerson ? "Sales Person is required ," : ""}
        ${bdfData?.gstOrPan !== "Not Registered" && activeTabInner != "F" // Only show validation if GST or PAN is selected
            ? isGSTSelected
              ? bdfErrors?.gstNumber !== null
                ? "Either GST is Invalid or left empty"
                : ""
              : isPANSelected && bdfErrors?.panNumber !== null
                ? "Either PAN is Invalid or left empty"
                : ""
            : ""
          }
        `,
      });
    } else {
      let dateFlag = areDatesProvided();
      if (dateFlag) {
        return;
      }
      let totalRPM = 0;
      let totalSpecialRate = 0;

      //🤷‍♀️🤷‍♀️

      // Prepare the confirmation modal function
      const showConfirmationModal = (overlappingBlocks) =>
        new Promise((resolve) => {
          // Define table columns
          const columns = [
            {
              title: "Location",
              dataIndex: "location",
              key: "location",
            },
            {
              title: "Start date",
              dataIndex: "blockedFrom",
              key: "blockedFrom",
            },
            {
              title: "End date",
              dataIndex: "blockedTo",
              key: "blockedTo",
            },
            {
              title: "Blocked by",
              dataIndex: "blockedBy",
              key: "blockedBy",
            },
            {
              title: "Blocked for",
              dataIndex: "blockedFor",
              key: "blockedFor",
            },
          ];

          // Display modal with table
          Modal.confirm({
            title:
              "Following inventories are blocked, do you still want to proceed?",
            width: 1000,
            content: (
              <Table
                dataSource={overlappingBlocks}
                columns={columns}
                pagination={false}
                bordered
              />
            ),
            onOk: () => resolve(true),
            onCancel: () => resolve(false),
          });
        });

      // Ensure confirmation before proceeding with blocked inventories
      const handleBlockedInventories = async () => {
        const allBlockedInventories = [];

        for (const ele of inventories) {
          const startDate = new Date(ele?.startDate);
          const endDate = new Date(ele?.endDate);

          const overlappingBlocks = ele?.blockedDates?.filter((blockedDate) => {
            const blockedStart = new Date(blockedDate?.blockedAt);
            const blockedEnd = new Date(blockedDate?.blockedTill);

            return (
              (startDate <= blockedEnd && startDate >= blockedStart) ||
              (endDate >= blockedStart && endDate <= blockedEnd) ||
              (startDate <= blockedStart && endDate >= blockedEnd)
            );
          });

          // Add overlapping blocks to the data source
          if (overlappingBlocks?.length > 0) {
            overlappingBlocks.forEach((blockedDate) => {
              allBlockedInventories.push({
                key: allBlockedInventories.length,
                location: ele.location,
                blockedFrom: moment(blockedDate.blockedAt).format("DD-MM-YYYY"),
                blockedTo: moment(blockedDate.blockedTill).format("DD-MM-YYYY"),
                blockedBy: blockedDate.blockedBy.name,
                blockedFor: blockedDate.blockedFor.name,
              });
            });
          }
        }

        if (allBlockedInventories?.length > 0) {
          const userConfirmed = await showConfirmationModal(
            allBlockedInventories,
          );
          if (!userConfirmed) {
            return false; // Stop execution if user cancels
          }
        }

        return true; // Continue execution if user confirms
      };

      // Call the function to handle blocked inventories
      const proceed = await handleBlockedInventories();
      if (!proceed) {
        return; // Stop further processing
      }

      //🤷‍♀️🤷‍♀️

      // const updatedInventories = inventories.map((ele) => {
      //   const startDate = new Date(ele?.startDate);
      //   const endDate = new Date(ele?.endDate);

      //   const startYear = startDate.getFullYear();
      //   const startMonth = startDate.getMonth();
      //   const startDay = startDate.getDate();
      //   const endYear = endDate.getFullYear();
      //   const endMonth = endDate.getMonth();
      //   const endDay = endDate.getDate();

      //   let fullMonths = 0;
      //   let remainingDays = 0;

      //   const isStartFullMonth = startDay === 1;
      //   const isEndFullMonth = endDay === new Date(endYear, endMonth + 1, 0).getDate();

      //   if (isStartFullMonth && isEndFullMonth) {
      //     // Case 1: Full months
      //     fullMonths = (endYear - startYear) * 12 + (endMonth - startMonth) + 1;
      //   } else {

      //     fullMonths = (endYear - startYear) * 12 + (endMonth - startMonth);

      //     if (!isStartFullMonth) {
      //       fullMonths -= 1;
      //       remainingDays += new Date(startYear, startMonth + 1, 0).getDate() - startDay + 1; // Days remaining in the start month
      //     }

      //     if (!isEndFullMonth) {
      //       remainingDays += endDay;
      //     }

      //     if (startYear === endYear && startMonth === endMonth) {
      //       remainingDays = endDay - startDay + 1;
      //       fullMonths = 0;
      //     }
      //   }

      //   if (remainingDays >= 30) {
      //     fullMonths += Math.floor(remainingDays / 30);
      //     remainingDays %= 30;
      //   }

      //   const daysInStartMonth = new Date(startYear, startMonth + 1, 0).getDate();
      //   const dailyRate = ele?.specialRatePerMonth / daysInStartMonth;
      //   const totalCost = fullMonths * ele?.specialRatePerMonth + remainingDays * dailyRate;

      //   const perDayRpm = ele?.ratePerMonth / daysInStartMonth;
      //   const srPerDay = ele?.specialRatePerMonth / daysInStartMonth;

      //   const newSpecialRate = totalCost;
      //   const discount = 100 - (srPerDay * 100) / perDayRpm;

      //   // Check for missing data or invalid discount
      //   if (!ele.suffixCode && (!ele.startDate || !ele.endDate)) {
      //     notification.error({
      //       message: `${ele.location} dates are left empty`,
      //     });
      //     flag = true;
      //     return ele; // Continue to next item
      //   }

      //   totalRPM += Number(ele.ratePerMonth);
      //   totalSpecialRate += Number(ele.specialRate);

      //   // Update `discount` and `newSpecialRate` for the current inventory item
      //   return {
      //     ...ele,
      //     discount: parseFloat(discount.toFixed(2)), // Round to 2 decimal places
      //     specialRate: parseFloat(newSpecialRate.toFixed(2)),
      //   };
      // });

      // let overallDiscount = discountCalc(totalSpecialRate,totalRPM)
      // if(overallDiscount>20 && !bdfData.packageRate){
      //   notification.error({
      //     message: `Overall Discount has exceeded the discount of 20%`,
      //   });
      //   return;
      // }
      // if (flag) {
      //   notification.error({ message: "BDF cannot be created" });
      //   return;
      // }

      const searchParams = window.location.search.startsWith("?")
        ? window.location.search.substring(1)
        : "";

      try {
        // Resolve parentCompanyId at submit: use bdfData, or find in companies by name (companies load on editor open so this works even if user saves before Tab 1 options render)
        const getCompanyId = (c) => c?._id ?? c?.objectId ?? c?.id ?? null;
        let resolvedParentCompanyId = bdfData?.parentCompanyId || null;
        if (
          !resolvedParentCompanyId &&
          bdfData?.parentCompanyName &&
          Array.isArray(companies) &&
          companies.length > 0
        ) {
          const match = companies.find(
            (c) => c?.name === bdfData.parentCompanyName,
          );
          resolvedParentCompanyId = match ? getCompanyId(match) : null;
        }

        let postData = {
          ...bdfData,
          campaignName: bdfData?.campaignName
            ? bdfData.campaignName.toUpperCase()
            : bdfData?.campaignName,
          brandName: bdfData?.brandName
            ? bdfData.brandName.toUpperCase()
            : bdfData?.brandName,
          billingPartyName: bdfData?.billingPartyName
            ? bdfData.billingPartyName.toUpperCase()
            : bdfData?.billingPartyName,
          parentCompanyId: resolvedParentCompanyId,
          inventories: sanitizeInventories(inventories),
          suffixInventories,
          bdfId,
        };
        const apiUrl = isOnHold
          ? `${apiBaseUrl}/inventoryManagement/editOnHoldBDF`
          : `${apiBaseUrl}/inventoryManagement/editBDF`;

        let response = await fetch(apiUrl, {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            authorization: `Token ${window.localStorage.getItem("token")}`,
          },
          body: JSON.stringify(postData),
        });
        let responseJSON = await response.json();
        // let responseJSON = {success:true};
        if (responseJSON.success) {
          notification.success({ message: responseJSON.message });
          // createBDFExcel(bdfData, inventories, proposalInvs);
          setBdfData({
            gstNumber: null,
            panNumber: null,
            bdfDate: moment().format("DD-MM-YYYY"),
            bdfNumber: null,
            salesPerson: null,
            salesPersonBaseLocation: null,
            mediaPlannerName: null,
            clientCategory: null,
            leadFrom: salesMan,
            ro: null,
            remark: null,
            parentCompanyName: null,
            parentCompanyId: null,
            brandName: null,
            brandId: null,
            billingPartyName: null,
            campaignName: null,
            billingAddress: null,
            // brandCategory: null,
            brandSegment: null,
            // brandCategory: null,
            contactPerson: null,
            contactNumber: null,
            emailId: null,
            // modeOfPayment: null,
            creditPeriod: null,
            campaignDuration: null,
            clientId: null,
            packageRate: null,
            getTypeOfBDF: activeTabInner,
          });
          setEditedRows({});
          if (isOnHold) {
            navigate("/clients-bookings?tab=2");
          } else {
            const url = searchParams
              ? `/clients-bookings?tab=1&${searchParams}`
              : `/clients-bookings?tab=1`;

            navigate(url);
            // navigate("/clients-bookings");
          }
        } else {
          notification.error({ message: responseJSON.message });
        }
      } catch (err) {
        console.log("Error: ", err.message);
      }
    }
  };
  const fetchProposalInfo = async (id) => {
    try {
      let response = await fetch(
        `${apiBaseUrl}/inventoryManagement/getProposalInfo`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `Token ${window.localStorage.getItem("token")}`,
          },
          body: JSON.stringify({ id: id }),
        },
      );
      let data = await response.json();
      return data;
    } catch (err) {
      console.error(`Error : ${err.message}`);
    }
  };
  // Define items for Tabs component
  const items = [
    { key: "1", label: "Detail Type 1" },
    { key: "2", label: "Detail Type 2" },
    { key: "3", label: "Detail Type 3" },
  ];
  function handleGSTChange(e) {
    setBdfData((prev) => {
      return {
        ...prev,
        gstNumber: e.target.value,
      };
    });
  }
  async function handleGSTFetch(e) {
    // if (!proposalInvs?.clientId) {
    await fetchClientByGST(e.target.value, bdfData?.parentCompanyName);
    // }
  }

  async function handleGSTFetch2(value, partyName) {
    // if (!proposalInvs?.clientId) {
    await fetchClientByGST(value, partyName ?? bdfData?.parentCompanyName);
  }

  // Function to render component based on active tab
  const renderTabContent = () => {
    switch (activeTab) {
      case "1":
        return (
          <TabContent1
            setActiveTab={setActiveTab}
            bdfData={bdfData}
            setBdfData={setBdfData}
            handleChange={handleChange}
            optionsForBrands={optionsForBrands}
            handleGSTChange={handleGSTChange}
            handleGSTFetch2={handleGSTFetch2}
            handleGSTFetch={handleGSTFetch}
            bdfErrors={bdfErrors}
            handleErrors={handleErrors}
            inputLabel={inputLabel}
            setInputLabel={setInputLabel}
            inputValue={inputValue}
            setInputValue={setInputValue}
            navigate={navigate}
            activeTabInner={activeTabInner}
            setActiveTabInner={setActiveTabInner}
            inputGSTValue={inputGSTValue}
            setInputGSTValue={setInputGSTValue}
            salesPersons={salesPersons}
            setSalesPersons={setSalesPersons}
            segmentCategories={segmentCategories}
            companies={companies}
            companiesLoading={companiesLoading}
          />
        );
      case "2":
        return (
          <TabContent2
            setActiveTab={setActiveTab}
            bdfData={bdfData}
            setBdfData={setBdfData}
            handleChange={handleChange}
            bdfErrors={bdfErrors}
            handleErrors={handleErrors}
            activeTabInner={activeTabInner}
            setActiveTabInner={setActiveTabInner}
          />
        );
      case "3":
        return (
          <TabContent3
            excelActionsEl={excelActionsEl}
            setActiveTab={setActiveTab}
            inventories={inventories}
            setInventories={setInventories}
            suffixInventories={suffixInventories}
            setSuffixInventories={setSuffixInventories}
            handleBDFEdit={handleBDFEdit}
            handleErrorsSubmission={handleErrorsSubmission}
            proposalInvs={proposalInvs}
            err={err}
            setErr={setErr}
            handleChange={handleChange}
            navigate={navigate}
            bdfData={bdfData}
            bdfId={bdfId}
            activeTabInner={activeTabInner}
            setActiveTabInner={setActiveTabInner}
            editedRows={editedRows}
            setEditedRows={setEditedRows}
            id={id}
            isPackageRateEnabled={isPackageRateEnabled}
            setIsPackageRateEnabled={setIsPackageRateEnabled}
            packageRate={packageRate}
            setPackageRate={setPackageRate}
            includePrintingCharge={includePrintingCharge}
            setIncludePrintingCharge={setIncludePrintingCharge}
            includeMountingCharge={includeMountingCharge}
            setIncludeMountingCharge={setIncludeMountingCharge}
            printingCost={printingCost}
            setPrintingCost={setPrintingCost}
            mountingCost={mountingCost}
            setMountingCost={setMountingCost}
            showInnovationChargeColumn={showInnovationChargeColumn}
            setShowInnovationChargeColumn={setShowInnovationChargeColumn}
          />
        );
      default:
        return null;
    }
  };
  const handleDraftSave = () => {
    dispatch(saveDraft({ inventories: inventories, bdfData: bdfData }));
    notification.success({ message: "Form Data Saved as Draft" });
  };

  const handleTabClick = (tab) => {
    setBdfData((prevState) => ({
      ...prevState,
      getTypeOfBDF: tab,
      bdfType: tab,
    }));
    setActiveTabInner(tab);
    if (partyChanged) {
      setInputGSTValue(`-${tab}`);
      //gst emptied on tab change
      handleChange("gstNumber", "");
    }
  };

  return (
    <div className="parent-padding-container">
      <div id="TabsAndBtn">
        <Tabs
          defaultActiveKey="1"
          activeKey={activeTab}
          onChange={onChange}
          items={items}
        />
        <div ref={setExcelActionsEl} style={{ display: "flex", gap: "1rem" }} />
      </div>
      {bdfData?.gstPercentage || bdfData?.cashPercentage ? (
        <div
          className="bdf-type"
          style={{
            fontWeight: "bold",
            color: "#212529cc",
            fontSize: "1.5rem",
          }}
        >
          {bdfData?.gstPercentage && `GST: ${bdfData.gstPercentage} %`}
          {bdfData?.cashPercentage && `Discount: ${bdfData.cashPercentage} %`}
        </div>
      ) : (
        <div className="bdf-type">
          <div className="bdf-type-child">
            {["A", typeOfBDF !== "A" && "F", typeOfBDF !== "A" && "R"]
              .filter(Boolean)
              .map((tab) => (
                <div
                  key={tab}
                  className="types"
                  style={{
                    backgroundColor:
                      activeTabInner === tab ? "#FFEC00" : "#ddd",
                  }}
                  onClick={() => handleTabClick(tab)}
                >
                  <p style={{ margin: 0 }}>{tab}</p>
                </div>
              ))}
          </div>
        </div>
      )}
      {renderTabContent()}
    </div>
  );
};

export default BDFEditorContainer;

const TabContent1 = ({
  setActiveTab,
  bdfData,
  setBdfData,
  handleChange,
  optionsForBrands,
  handleGSTChange,
  handleGSTFetch,
  handleGSTFetch2,
  bdfErrors,
  inputLabel,
  setInputLabel,
  inputValue,
  setInputValue,
  handleErrors,
  navigate,
  activeTabInner,
  inputGSTValue,
  setInputGSTValue,
  salesPersons,
  setSalesPersons,
  segmentCategories,
  companies = [],
  companiesLoading = false,
}) => {
  const [options, setOptions] = useState([]);
  const [gstNumbers, setGstNumbers] = useState([]);
  const [isSelectVisible, setIsSelectVisible] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [subCategories, setSubCategories] = useState([]);
  const [selectedSegmentName, setSelectedSegmentName] = useState(null);

  // Fetch subcategories when segment is selected
  const fetchSubCategories = async (segmentName) => {
    if (!segmentName || segmentName === "OTHERS") {
      setSubCategories([]);
      setSelectedSegmentName(null);
      return;
    }

    // Find the segment category by name to get its ID
    const selectedSegment = segmentCategories.find(
      (seg) => seg.name === segmentName,
    );

    if (!selectedSegment || !selectedSegment._id) {
      setSubCategories([]);
      setSelectedSegmentName(null);
      return;
    }

    try {
      const response = await fetch(
        `${apiBaseUrl}/inventoryManagement/getSegmentSubCategoriesByCategory?categoryId=${selectedSegment._id}`,
        {
          method: "GET",
          credentials: "include",
        },
      );
      const data = await response.json();
      if (data.success && Array.isArray(data.data) && data.data.length > 0) {
        setSubCategories(data.data);
        setSelectedSegmentName(segmentName);
      } else {
        setSubCategories([]);
        setSelectedSegmentName(null);
      }
    } catch (error) {
      console.error("Error fetching subcategories:", error);
      setSubCategories([]);
      setSelectedSegmentName(null);
    }
  };

  useEffect(() => {
    fetchGSTNumbers();
  }, []);

  // Fetch subcategories when segmentCategories are loaded and brandSegment is set
  useEffect(() => {
    if (bdfData?.brandSegment && segmentCategories.length > 0) {
      fetchSubCategories(bdfData.brandSegment);
    }
  }, [segmentCategories, bdfData?.brandSegment]);

  const fetchSuggestions = (query) => {
    if (query && optionsForBrands) {
      const filteredClients = optionsForBrands
        ?.filter((client) =>
          client?.label?.toLowerCase().includes(query?.toLowerCase()),
        )
        .map((client) => ({ value: client.value, label: client.label }));
      if (filteredClients?.length == 0) {
        setOptions(optionsForBrands);
      } else {
        setOptions(filteredClients);
      }
    } else {
      setOptions([]);
    }
  };
  const onSearch = (value) => {
    setInputValue(value);
    handleChange("brandName", value);
    handleChange("brandId", null);
    setInputLabel(""); // Clear the input label to show the user's input
    fetchSuggestions(value);
  };

  const onSelect = (value, option) => {
    setInputValue(value);
    setInputLabel(option.label); // Set the input label to the selected option's label
    handleChange("brandName", option.label);
    handleChange("brandId", value);
  };

  // const onBlur = () => {
  //   if (!inputLabel) {
  //     setClientName(inputValue);
  //   }
  // };

  const onClear = () => {
    setInputValue("");
    setInputLabel("");
    handleChange("brandName", "");
  };

  const fetchGSTNumbers = async () => {
    try {
      const response = await fetch(
        `${apiBaseUrl}/inventoryManagement/getAllGSTNumbers`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      const responseJSON = await response.json();

      if (response.ok) {
        setGstNumbers(responseJSON.gstNumbers);
      } else {
        notification.error({
          message: responseJSON.message || "Failed to fetch GST Numbers",
        });
      }
    } catch (error) {
      console.error(`Error fetching GST Numbers: ${error.message}`);
      notification.error({
        message: "An error occurred while fetching GST Numbers",
      });
    }
  };

  // Set parentCompanyId when BDF data loads with parentCompanyName but no parentCompanyId (companies come from parent, loaded on editor open)
  useEffect(() => {
    if (
      bdfData?.parentCompanyName &&
      (!bdfData?.parentCompanyId || bdfData?.parentCompanyId === null) &&
      companies.length > 0
    ) {
      const matchingCompany = companies.find(
        (company) => company.name === bdfData.parentCompanyName,
      );
      if (matchingCompany) {
        handleChange(
          "parentCompanyId",
          matchingCompany._id || matchingCompany.objectId,
        );
        setSelectedCompany(matchingCompany);
      }
    }
  }, [bdfData?.parentCompanyName, bdfData?.parentCompanyId, companies]);

  const handleCompanyChange = (companyName) => {
    const selected = companies.find((company) => company.name === companyName);

    if (selected) {
      setSelectedCompany(selected);
      handleChange("parentCompanyName", companyName);
      handleChange("parentCompanyId", selected._id || selected.objectId);

      const category = selected?.category;
      if (isValidCompanyCategory(category)) {
        handleChange("clientCategory", category);
      } else {
        handleChange("clientCategory", null);
      }

      if (selected.gstNumber) {
        handleChange("gstNumber", selected.gstNumber);
        setInputGSTValue(selected.gstNumber);
        handleGSTFetch2(selected.gstNumber, companyName);
      } else {
        handleChange("gstNumber", "");
        setInputGSTValue("");
        // Call API with partyName only so we can prefill form data even when GST is not present
        handleGSTFetch2(null, companyName);
      }
    } else {
      setSelectedCompany(null);
      handleChange("parentCompanyId", null);
      handleChange("clientCategory", null);
    }
  };

  const handleInputClick = () => {
    if (gstNumbers.length === 0) {
      fetchGSTNumbers();
    }
    setIsSelectVisible(true);
  };

  const handleSelectChange = (value) => {
    setInputGSTValue(value);
    // setInputLabel(value);
    setIsSelectVisible(false);
  };

  const checkGstNeeded = () => {
    if (
      activeTabInner == "B" ||
      activeTabInner == "C" ||
      activeTabInner == "F"
    ) {
      return false;
    } else {
      return true;
    }
  };

  // console.log("bdfData:: ", bdfData);

  return (
    <>
      <div className="Tab-content-bdf">
        <div className="Tab-content-bdf-child">
          <div className="Tab-content-bdf-left-section bdf-tab-section">
            <div className="bdf-field">
              <div className="bdf-field-name">
                {bdfData?.gstOrPan === "PAN Number"
                  ? "PAN Number"
                  : bdfData?.gstOrPan === "Not Registered"
                    ? "Not Registered"
                    : "GST Number"}
                {bdfData?.gstOrPan !== "Not Registered" &&
                  activeTabInner != "F" && (
                    <span className="error-code">*</span>
                  )}
              </div>

              {bdfData?.gstOrPan !== "Not Registered" && (
                <div className="bdf-input-parent">
                  {bdfData?.gstOrPan === "PAN Number" ? (
                    // If gstOrPan is "PAN Number", show a simple input field
                    <Input
                      className="custom-input-bdf"
                      value={bdfData?.panNumber || ""}
                      placeholder="Enter PAN Number"
                      onChange={(e) =>
                        handleChange("panNumber", e.target.value)
                      }
                    />
                  ) : (
                    <AutoComplete
                      options={gstNumbers.map((ele) => {
                        return {
                          label: ele,
                          value: ele,
                        };
                      })}
                      filterOption={(inputGSTValue, option) =>
                        option.value
                          .toUpperCase()
                          .indexOf(inputGSTValue.toUpperCase()) !== -1
                      }
                      // disabled={
                      //   activeTabInner == "B" ||
                      //   activeTabInner == "C" ||
                      //   activeTabInner == "F"
                      // }
                      onBlur={(e) => {
                        handleGSTFetch(e);
                        handleErrors(
                          "gstNumber",
                          e.target.value || inputGSTValue || bdfData?.gstNumber,
                        );
                      }}
                      onSearch={(value) => {
                        handleChange("gstNumber", value);
                      }}
                      value={inputGSTValue || bdfData?.gstNumber} // Display input label if available, otherwise input value
                      onChange={(value) => {
                        handleSelectChange(value);
                        handleGSTFetch2(value);
                        handleChange("gstNumber", value);
                        handleErrors(
                          "gstNumber",
                          value || inputGSTValue || bdfData?.gstNumber,
                        );
                      }}
                      // onBlur={onBlur}
                      placeholder="Select a client"
                      style={{ width: "100%" }}
                      allowClear
                      onClear={onClear} // Handle the clear event
                    >
                      <Input
                        className="custom-input-bdf"
                      // disabled={
                      //   activeTabInner == "B" ||
                      //   activeTabInner == "C" ||
                      //   activeTabInner == "F"
                      // }
                      />
                    </AutoComplete>
                  )}

                  {bdfData?.gstOrPan === "PAN Number"
                    ? bdfErrors.panNumber && (
                      <div className="bdf-form-error">
                        {bdfErrors.panNumber}
                      </div>
                    )
                    : bdfErrors.gstNumber && (
                      <div className="bdf-form-error">
                        {bdfErrors.gstNumber}
                      </div>
                    )}
                </div>
              )}
            </div>
            <div className="bdf-field">
              <div className="bdf-field-name">BDF Date</div>
              <div className="bdf-input-parent">
                <Input
                  className="custom-input-bdf"
                  value={bdfData?.bdfDate}
                  disabled={true}
                  style={{
                    backgroundColor: "#f5f5f5",
                    color: "#999",
                    border: "1px solid #ddd",
                    borderRadius: "5px",
                  }}
                />
              </div>
            </div>
            {/* <div className="bdf-field">
              <div className="bdf-field-name">Serial BDF No.</div>
              <div className="bdf-input-parent">
                <Input
                  className="custom-input-bdf"
                  value={bdfData?.bdfNumber}
                  onChange={(e) => handleChange("bdfNumber", e.target.value)}
                />
              </div>
            </div> */}
            <div className="bdf-field">
              <div className="bdf-field-name">
                Sales Person Name
                <span class="error-code">*</span>
              </div>
              <div className="bdf-input-parent">
                {/* <Input
                  className="custom-input-bdf"
                  value={bdfData?.salesPerson}
                  onChange={(e) => handleChange("salesPerson", e.target.value)}
                /> */}
                <Select
                  style={{ width: "100%" }}
                  value={bdfData?.salesPerson || undefined}
                  options={salesPersons}
                  onChange={(value) => handleChange("salesPerson", value)}
                  placeholder="Select sales person"
                  showSearch
                  optionFilterProp="value"
                  filterOption={(inputValue, option) =>
                    String(option?.value || "")
                      .toLowerCase()
                      .includes(inputValue.toLowerCase())
                  }
                  onBlur={() => {
                    handleErrors("salesPerson", bdfData?.salesPerson);
                  }}
                  allowClear
                />
                {bdfErrors.salesPerson && (
                  <div className="bdf-form-error">{bdfErrors.salesPerson}</div>
                )}
              </div>
            </div>
            <div className="bdf-field">
              <div className="bdf-field-name">Salesman Base Location</div>
              <div className="bdf-input-parent">
                <Input
                  className="custom-input-bdf"
                  value={bdfData?.salesPersonBaseLocation}
                  onChange={(e) =>
                    handleChange("salesPersonBaseLocation", e.target.value)
                  }
                />
              </div>
            </div>
            <div className="bdf-field">
              <div className="bdf-field-name">Media Planner Name</div>
              <div className="bdf-input-parent">
                <Input
                  className="custom-input-bdf"
                  value={bdfData?.mediaPlannerName}
                  onChange={(e) =>
                    handleChange("mediaPlannerName", e.target.value)
                  }
                />
              </div>
            </div>
            <div className="bdf-field">
              <div className="bdf-field-name">Client Category</div>
              <div className="bdf-input-parent">
                <Select
                  className="custom-select-bdf"
                  value={
                    isValidCompanyCategory(bdfData?.clientCategory)
                      ? bdfData?.clientCategory
                      : undefined
                  }
                  onChange={(value) => {
                    handleChange("clientCategory", value);
                  }}
                >
                  {COMPANY_CATEGORIES.map((category) => (
                    <Option key={category} value={category}>
                      {category}
                    </Option>
                  ))}
                </Select>
              </div>
            </div>
            <div className="bdf-field">
              <div className="bdf-field-name">Lead From </div>
              <div className="bdf-input-parent">
                <Input
                  className="custom-input-bdf"
                  value={bdfData?.leadFrom}
                  onChange={(e) => handleChange("leadFrom", e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="Tab-content-bdf-right-section bdf-tab-section">
            {/* <div className="bdf-field">
              <div className="bdf-field-name">
                Parent Company Name <span class="error-code">*</span>
              </div>
              <div className="bdf-input-parent">
                <AutoComplete
                  options={companies.map((ele) => {
                    return {
                      label: ele.name,
                      value: ele.name,
                    };
                  })}
                  filterOption={(input, option) =>
                    option?.value?.toLowerCase().includes(input?.toLowerCase())
                  }
                  onSearch={(value) => {
                    handleChange("parentCompanyName", value);
                  }}
                  value={bdfData?.parentCompanyName}
                  onChange={handleCompanyChange}
                  placeholder="Select a client"
                  style={{ width: "100%" }}
                  allowClear
                  onClear={onClear}
                >
                  <Input className="custom-input-bdf" />
                </AutoComplete>
                {bdfErrors.parentCompanyName && (
                  <div className="bdf-form-error">
                    {bdfErrors.parentCompanyName}
                  </div>
                )}
              </div>
            </div> */}

            <div className="bdf-field">
              <div className="bdf-field-name">
                Parent Company Name <span class="error-code">*</span>
              </div>
              <div className="bdf-input-parent">
                <Select
                  options={companies.map((ele) => ({
                    label: ele.name,
                    value: ele.name,
                  }))}
                  value={bdfData?.parentCompanyName}
                  onChange={(value) => {
                    if (value === undefined) {
                      // This handles the clear action
                      handleChange("parentCompanyName", "");
                      handleChange("parentCompanyId", null);
                      setSelectedCompany(null);
                      handleChange("clientCategory", null);
                      handleChange("gstNumber", "");
                      setInputGSTValue && setInputGSTValue("");
                      handleChange("brandName", "");
                    } else {
                      handleCompanyChange(value);
                    }
                  }}
                  placeholder="Select a parent company"
                  style={{ width: "100%" }}
                  allowClear
                  // onClear={onClear}
                  className="custom-input-bdf"
                  showSearch
                  loading={companiesLoading}
                  notFoundContent={
                    companiesLoading ? (
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 8,
                          padding: "6px 8px",
                        }}
                      >
                        <Spin size="small" />
                        Loading companies...
                      </span>
                    ) : (
                      "No companies available"
                    )
                  }
                  filterOption={(input, option) =>
                    option?.label?.toLowerCase().includes(input.toLowerCase())
                  }
                />
                {bdfErrors?.parentCompanyName && (
                  <div className="bdf-form-error">
                    {bdfErrors.parentCompanyName}
                  </div>
                )}
              </div>
            </div>

            <div className="bdf-field">
              <div className="bdf-field-name">
                Brand Name <span class="error-code">*</span>
              </div>
              <div className="bdf-input-parent">
                <AutoComplete
                  options={options}
                  onSelect={onSelect}
                  onSearch={onSearch}
                  value={inputLabel || inputValue || bdfData?.brandName} // Display input label if available, otherwise input value
                  onChange={(value) => {
                    setInputValue(value);
                    setInputLabel("");
                    handleErrors("brandName", value); // Call handleErrors here
                  }}
                  // onBlur={onBlur}
                  placeholder="Select a client"
                  style={{ width: "100%" }}
                  allowClear
                  onClear={onClear} // Handle the clear event
                >
                  <Input
                    className="custom-input-bdf"
                    style={{ textTransform: "uppercase" }}
                  />
                </AutoComplete>
                {bdfErrors.brandName && (
                  <div className="bdf-form-error">{bdfErrors.brandName}</div>
                )}
              </div>
            </div>
            <div className="bdf-field">
              <div className="bdf-field-name">Billing Party Name</div>
              <div className="bdf-input-parent">
                <Input
                  className="custom-input-bdf"
                  style={{ textTransform: "uppercase" }}
                  value={bdfData?.billingPartyName}
                  onChange={(e) =>
                    handleChange("billingPartyName", e.target.value)
                  }
                />
              </div>
            </div>
            <div className="bdf-field">
              <div className="bdf-field-name">
                Campaign Name <span className="error-code">*</span>
              </div>
              <div className="bdf-input-parent">
                <Input
                  className="custom-input-bdf"
                  style={{ textTransform: "uppercase" }}
                  value={bdfData?.campaignName}
                  onChange={(e) => {
                    handleChange("campaignName", e.target.value);
                    handleErrors("campaignName", e.target.value);
                  }}
                />
                {bdfErrors.campaignName && (
                  <div className="bdf-form-error">{bdfErrors.campaignName}</div>
                )}
              </div>
            </div>
            <div className="bdf-field">
              <div className="bdf-field-name">Billing Address</div>
              <div className="bdf-input-parent">
                <Input
                  className="custom-input-bdf"
                  value={bdfData?.billingAddress}
                  onChange={(e) =>
                    handleChange("billingAddress", e.target.value)
                  }
                />
              </div>
            </div>

            <div className="bdf-field">
              <div className="bdf-field-name">
                Brand Segment <span class="error-code">*</span>
                {subCategories.length > 0 && selectedSegmentName && (
                  <Tooltip
                    title={
                      <div>
                        <div
                          style={{ fontWeight: "bold", marginBottom: "4px" }}
                        >
                          {selectedSegmentName} includes:
                        </div>
                        <div>
                          {subCategories
                            .map((subCat) => subCat.name)
                            .join(", ")}
                        </div>
                      </div>
                    }
                  >
                    <InfoCircleOutlined
                      className="info-icon-pulse"
                      style={{
                        marginLeft: "8px",
                        color: "#1890ff",
                        cursor: "pointer",
                        fontSize: "16px",
                        backgroundColor: "#e6f7ff",
                        borderRadius: "50%",
                        padding: "4px",
                        boxShadow: "0 0 0 2px rgba(24, 144, 255, 0.2)",
                      }}
                    />
                  </Tooltip>
                )}
              </div>
              <div className="bdf-input-parent">
                <Select
                  className="custom-select-bdf"
                  value={bdfData?.brandSegment}
                  onChange={(value) => {
                    handleChange("brandSegment", value);
                    handleErrors("brandSegment", value);
                    fetchSubCategories(value);
                  }}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder="Search and select brand segment"
                >
                  {segmentCategories.map((segment) => (
                    <Option key={segment._id} value={segment.name}>
                      {segment.name}
                    </Option>
                  ))}
                  <Option value="OTHERS">OTHERS</Option>
                </Select>
                {/* <Input
                  className="custom-input-bdf"
                  value={bdfData?.brandSegment}
                  onChange={(e) => {
                    handleChange("brandSegment", e.target.value);
                    handleErrors("brandSegment", e.target.value);
                  }}
                /> */}
                {bdfErrors.brandSegment && (
                  <div className="bdf-form-error">{bdfErrors.brandSegment}</div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "end", gap: "1rem" }}>
          <Button onClick={() => setActiveTab("2")} type="primary">
            Next
          </Button>
        </div>
      </div>
    </>
  );
};
const TabContent2 = ({
  setActiveTab,
  bdfData,
  setBdfData,
  handleChange,
  bdfErrors,
  handleErrors,
  activeTabInner,
  setActiveTabInner,
}) => {
  const checkCreditPeriod = () => {
    if (
      activeTabInner == "A" ||
      activeTabInner == "C" ||
      activeTabInner == "D"
    ) {
      return true;
    } else {
      return false;
    }
  };
  const handlePOFileUpload = async (event) => {
    try {
      const file = event.target.files[0];
      if (!file) {
        throw new Error("No file selected");
      }

      const fileType = file.type;

      const requestBody = {
        fileName: encodeURIComponent(file.name),
        mime: fileType,
        acl: "public-read",
      };

      // Request upload policy
      const response = await fetch(`${apiBaseUrl}/chats/uploadPolicy`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `Token ${window.localStorage.getItem("token")}`,
        },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();

      if (data?.data?.fields && data?.data?.url) {
        const formData = new FormData();

        // Ensure Content-Type is set correctly for S3 policy
        const expectedContentType = fileType || "application/pdf";

        Object.entries(data.data.fields).forEach(([key, value]) => {
          // Override Content-Type if present to ensure exact match
          if (key.toLowerCase() === "content-type") {
            formData.append(key, expectedContentType);
          } else {
            formData.append(key, value);
          }
        });

        // Ensure Content-Type is set even if not in fields
        if (!formData.has("Content-Type") && !formData.has("content-type")) {
          formData.append("Content-Type", expectedContentType);
        }

        formData.append("file", file);

        const uploadResponse = await fetch(data.data.url, {
          method: "POST",
          body: formData,
        });

        if (uploadResponse.ok) {
          const finalUrl = convertS3ToCloudFront(
            `${data.data.url}/${encodeURIComponent(data.filePath)}`,
          );
          // console.log("This is the final URL for the RO file:", finalUrl);
          handleChange("roFile", finalUrl);
          notification.success({ message: "RO file uploaded successfully" });
        } else {
          notification.error({ message: "Error while uploading RO file" });
        }
      } else {
        notification.error({ message: "Error while uploading RO file" });
      }
    } catch (error) {
      console.error("An error occurred during file upload:", error);
      notification.error({ message: "An error occurred during file upload" });
    }
  };

  return (
    <>
      <div className="Tab-content-bdf">
        <div className="Tab-content-bdf-child">
          <div className="Tab-content-bdf-left-section bdf-tab-section">
            <div className="bdf-field">
              <div className="bdf-field-name">
                Contact Person <span class="error-code">*</span>
              </div>
              <div className="bdf-input-parent">
                <Input
                  className="custom-input-bdf"
                  value={bdfData?.contactPerson}
                  onChange={(e) =>
                    handleChange("contactPerson", e.target.value)
                  }
                  onBlur={(e) => handleErrors("contactPerson", e.target.value)}
                // disabled={activeTabInner == "B" || activeTabInner == "F"}
                // style={{
                //   backgroundColor:
                //     activeTabInner == "B" || activeTabInner == "F"
                //       ? "#F5F5F5"
                //       : "white",
                // }}
                />
                {bdfErrors.contactPerson && (
                  <div className="bdf-form-error">
                    {bdfErrors.contactPerson}
                  </div>
                )}
              </div>
            </div>
            <div className="bdf-field">
              <div className="bdf-field-name">
                Contact Number <span class="error-code">*</span>
              </div>
              <div className="bdf-input-parent">
                <Input
                  className="custom-input-bdf"
                  value={bdfData?.contactNumber}
                  onChange={(e) =>
                    handleChange("contactNumber", e.target.value)
                  }
                  onBlur={(e) => handleErrors("contactNumber", e.target.value)}
                />
                {bdfErrors.contactNumber && (
                  <div className="bdf-form-error">
                    {bdfErrors.contactNumber}
                  </div>
                )}
              </div>
            </div>
            <div className="bdf-field">
              <div className="bdf-field-name">
                Email <span class="error-code">*</span>
              </div>
              <div className="bdf-input-parent">
                <Input
                  className="custom-input-bdf"
                  value={bdfData?.emailId}
                  onChange={(e) => handleChange("emailId", e.target.value)}
                  onBlur={(e) => handleErrors("emailId", e.target.value)}
                />
                {bdfErrors.emailId && (
                  <div className="bdf-form-error">{bdfErrors.emailId}</div>
                )}
              </div>
            </div>
            <div className="bdf-field">
              <div className="bdf-field-name">Remark</div>
              <div className="bdf-input-parent">
                <Input
                  className="custom-input-bdf"
                  value={bdfData?.remark}
                  onChange={(e) => handleChange("remark", e.target.value)}
                // onBlur={(e) => handleErrors("Approved By", e.target.value)}
                />
                {/* {bdfErrors.approvedBy && (
                              <div className="bdf-form-error">{bdfErrors.creditPeriod}</div>
                            )} */}
              </div>
            </div>

            <div className="bdf-field">
              <div className="bdf-field-name">
                RO Upload/Confirmation <br />
                Screenshot
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                {/* Hidden File Input */}
                <input
                  type="file"
                  id="hiddenFileInput"
                  className="custom-input-bdf"
                  accept=".pdf,.jpg,.jpeg,.png"
                  style={{ display: "none" }}
                  onChange={handlePOFileUpload}
                />

                {/* Ant Design Button for Triggering File Input */}
                <Button
                  type="primary"
                  onClick={() =>
                    document.getElementById("hiddenFileInput").click()
                  }
                >
                  Upload RO File
                </Button>

                {/* Display Link to Uploaded File */}
                {bdfData?.roFile && (
                  <div
                    className="uploaded-file-link"
                    style={{ marginTop: "10px" }}
                  >
                    <a
                      href={getViewableFileUrl(bdfData.roFile)}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View Uploaded File
                    </a>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="Tab-content-bdf-right-section bdf-tab-section">
            <div className="bdf-field">
              {/* <div className="bdf-field-name">
                Mode Of Payment <span class="error-code">*</span>
              </div> */}
              {/* <div className="bdf-input-parent">
                <Input
                  className="custom-input-bdf"
                  value={bdfData?.modeOfPayment}
                  onChange={(e) => handleChange("modeOfPayment", e.target.value)}
                />
                <Select
                  className="custom-select-bdf"
                  value={bdfData?.modeOfPayment}
                  onChange={(value) => {
                    handleChange("modeOfPayment", value);
                  }}
                >
                  {["Cheque", "RTGS", "Barter", "Other"].map((category) => (
                    <Option key={category} value={category}>
                      {category}
                    </Option>
                  ))}
                </Select>
                {bdfErrors.modeOfPayment && (
                  <div className="bdf-form-error">
                    {bdfErrors.modeOfPayment}
                  </div>
                )}
              </div> */}
            </div>
            {/* <div className="bdf-field">
              <div className="bdf-field-name">Mode Of Payment</div>
              <div className="bdf-input-parent">
                <Input
                  className="custom-input-bdf"
                  value={bdfData?.modeOfPayment}
                  onChange={(e) =>
                    handleChange("modeOfPayment", e.target.value)
                  }
                  onBlur={(e) => handleErrors("modeOfPayment", e.target.value)}
                />
                {bdfErrors.modeOfPayment && (
                  <div className="bdf-form-error">
                    {bdfErrors.modeOfPayment}
                  </div>
                )}
              </div> */}
            {/* </div> */}
            <div className="bdf-field">
              <div className="bdf-field-name">
                Credit Period <span class="error-code">*</span>
              </div>
              <div className="bdf-input-parent">
                <Input
                  className="custom-input-bdf"
                  value={bdfData?.creditPeriod}
                  onChange={(e) => handleChange("creditPeriod", e.target.value)}
                  onBlur={(e) => handleErrors("creditPeriod", e.target.value)}
                />
                {bdfErrors.creditPeriod && (
                  <div className="bdf-form-error">{bdfErrors.creditPeriod}</div>
                )}
              </div>
            </div>
            <div className="bdf-field">
              <div className="bdf-field-name">Campaign Duration</div>
              <div className="bdf-input-parent">
                <Input
                  className="custom-input-bdf"
                  value={bdfData?.campaignDuration}
                  onChange={(e) =>
                    handleChange("campaignDuration", e.target.value)
                  }
                  disabled={true}
                  style={{
                    backgroundColor: "#f5f5f5",
                    color: "#999",
                    border: "1px solid #ddd",
                    borderRadius: "5px",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "end", gap: "1rem" }}>
          <Button onClick={() => setActiveTab("1")}>Back</Button>
          <Button onClick={() => setActiveTab("3")} type="primary">
            Next
          </Button>
        </div>
      </div>
    </>
  );
};

const TabContent3 = ({
  excelActionsEl,
  inventories,
  setInventories,
  suffixInventories,
  setSuffixInventories,
  handleBDFEdit,
  setActiveTab,
  handleChange,
  proposalInvs,
  bdfData,
  err,
  setErr,
  bdfId,
  editedRows,
  setEditedRows,
  id,
  isPackageRateEnabled,
  setIsPackageRateEnabled,
  includePrintingCharge, // New prop
  setIncludePrintingCharge, // New prop
  includeMountingCharge, // New prop
  setIncludeMountingCharge, // New prop
  printingCost,
  setPrintingCost,
  mountingCost,
  setMountingCost,
  packageRate,
  setPackageRate,
  showInnovationChargeColumn,
  setShowInnovationChargeColumn,
  activeTabInner,
}) => {
  const [searchText, setSearchText] = useState("");
  const [isSavingBdf, setIsSavingBdf] = useState(false);
  const [openInvs, setOpenInvs] = useState(false);
  const [openTradingInvs, setOpenTradingInvs] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [allInv, setAllInv] = useState(null);
  const [allInvD, setAllInvD] = useState(null);
  const [allTradingInv, setAllTradingInv] = useState(null);
  const [allTradingInvD, setAllTradingInvD] = useState(null);
  const [tradingSearchText, setTradingSearchText] = useState("");
  const [loadingTradingInvs, setLoadingTradingInvs] = useState(false);
  const [loadingRemovedInvs, setLoadingRemovedInvs] = useState(false);
  const [inventoryPickerType, setInventoryPickerType] = useState("trading");
  const dispatch = useDispatch();
  const inputRef = useRef(null);
  const didInitialize = useRef(false);
  let reduxInvs = useSelector((state) => state.inventoriesList.inventories);
  // Add Suffix
  const [cartCodeNos, setCartCodeNos] = useState([]);
  const [subBDFIds, setSubBDFIds] = useState([]);

  // Add Trading Inventory state
  const [addInventoryBoolean, setAddInventoryBoolean] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [previewURLs, setPreviewURLs] = useState([]);
  const [flag, setFlag] = useState(false);
  const [vendors, setVendors] = useState([]);
  const [form] = Form.useForm();
  function canAddToCart(items, cart) {
    console.log(items, cart);
    if (!Array.isArray(items) || items.length === 0 || !Array.isArray(cart)) {
      return { canAdd: true, reason: "" };
    }
    let sanitizedCart = cart
      .map((ele) => ele?.replace(/\s/g, ""))
      .filter((ele) => ele && !items.includes(ele));
    for (let it of items) {
      if (!it) {
        continue;
      }

      let item = it.replace(/\s/g, "");
      let mainGroup = item.split("-").slice(0, 2).join("-");
      let subGroups = item.split("-").slice(2);

      if (subGroups.length === 2) {
        let itemA = `${mainGroup}-${subGroups[0]}`;
        let itemB = `${mainGroup}-${subGroups[1]}`;

        if (sanitizedCart.includes(itemA)) {
          return {
            canAdd: false,
            reason: `Cannot add ${item} because ${itemA} is already in the cart.`,
          };
        }
        if (sanitizedCart.includes(itemB)) {
          return {
            canAdd: false,
            reason: `Cannot add ${item} because ${itemB} is already in the cart.`,
          };
        }
      } else if (subGroups.length === 1) {
        let itemA = subGroups[0];
        let combinedItems = sanitizedCart.filter((cartItem) => {
          let cartMainGroup = cartItem.split("-").slice(0, 2).join("-");
          let cartSubGroups = cartItem.split("-").slice(2);
          return (
            cartMainGroup === mainGroup &&
            cartSubGroups.length === 2 &&
            (cartSubGroups[0] === itemA || cartSubGroups[1] === itemA)
          );
        });

        if (combinedItems.length > 0) {
          return {
            canAdd: false,
            reason: `Cannot add ${item} because ${combinedItems[0]} is already in the cart.`,
          };
        }
      }
    }

    return { canAdd: true, reason: "" };
  }
  const [open, setOpen] = useState(false);
  const showModal = () => {
    setOpen(true);
  };

  const handleCancel = () => {
    setOpen(false);
  };
  const handleDeleteS = (record) => {
    const newData = suffixInventories.filter((item) => item.key !== record.key);
    setSuffixInventories(newData);
  };

  // Add Trading Inventory functions
  useEffect(() => {
    if (addInventoryBoolean) {
      fetchVendors();
    }
  }, [addInventoryBoolean]);

  const fetchVendors = async () => {
    try {
      let response = await fetch(
        `${apiBaseUrl}/inventoryManagement/getAllTradingParties`,
        {
          method: "GET",
          credentials: "include",
        },
      );
      let responseJson = await response.json();

      if (responseJson?.success) {
        const vendorList = responseJson?.data?.map((party) => ({
          name: party?.name,
          gstNumber: party?.gstNumber,
        }));
        setVendors(vendorList);
      }
    } catch (error) {
      console.error("Error fetching vendors:", error);
    }
  };

  const handleUpload = () => {
    document.querySelector(".add-inventory-image-upload input")?.click();
  };

  const handleFileChange = (event) => {
    setFlag(false);
    const files = Array.from(event.target.files);
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(reader.result);
      };
      reader.readAsDataURL(file);
    }

    // List of allowed MIME types for images and videos
    const allowedTypes = [
      "image/jpeg",
      "image/png",
      "image/gif",
      "image/jpg",
      "image/heic",
      "video/mp4",
      "video/webm",
      "video/ogg",
      "video/x-msvideo", // AVI
      "video/quicktime", // MOV
      // Add more MIME types as needed
    ];

    // Check if any selected file is not an allowed type
    const hasNonAllowedType = files.some(
      (file) => !allowedTypes.includes(file.type),
    );

    if (hasNonAllowedType) {
      notification.error({
        message: "You are only allowed to upload image.",
      });

      // Clear the selected files
      event.target.value = null;
      return;
    }

    // Create an array of FileReaders to read the selected files
    const readers = files.map((file) => {
      const reader = new FileReader();
      reader.onload = () => {
        setPreviewURLs((prevPreviewURLs) => [
          ...prevPreviewURLs,
          reader.result,
        ]);
      };
      reader.readAsDataURL(file);
      return reader;
    });
    event.target.value = null;

    // Set the selectedFiles state after processing the files
    setSelectedFiles([]);
    setSelectedFiles((prevSelectedFiles) => [...prevSelectedFiles, ...files]);
    setFlag(true);
  };

  useEffect(() => {
    if (flag) {
      handleFileSelectOfPreview();
    }
  }, [flag]);

  const handleFileSelectOfPreview = async () => {
    for (const file of selectedFiles) {
      let filenamee = file.name;
      let typeOfFile = file.type;
      let filename = filenamee;
      let mime = typeOfFile.split("/")[1];
      const requestBody = {
        fileName: filename,
        mime: mime,
        // acl: "public-read",
      };
      const response = await fetch(
        `${apiBaseUrl}/inventoryManagement/uploadPolicy`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `Token ${window.localStorage.getItem("token")}`,
          },
          body: JSON.stringify(requestBody),
        },
      );
      const data = await response.json();
      const formData = new FormData();

      // Add all fields from the upload policy, but skip content-type
      // The browser will handle Content-Type automatically when appending the file
      for (const [key, value] of Object.entries(data.data.fields)) {
        // Skip content-type field - let browser handle it automatically
        if (key.toLowerCase() !== "content-type") {
          formData.set(key, value);
        }
      }

      // Add the file - browser will handle Content-Type automatically
      formData.append("file", file);
      const finalurl = convertS3ToCloudFront(
        `${data.data.url}/${data.filePath}`,
      );
      setImageUrl(finalurl);
      try {
        const almostFinalResponse = await fetch(data.data.url, {
          method: "POST",
          body: formData,
        });

        if (almostFinalResponse.ok) {
          console.log("its working");
        } else {
          console.log(
            "Error occurred:",
            almostFinalResponse.status,
            almostFinalResponse.statusText,
          );
        }
      } catch (error) {
        console.log("Error occurred:", error);
      }
    }
  };

  const addSingleTradingInventory = async (body) => {
    try {
      const inventoryResponse = await fetch(
        `${apiBaseUrl}/inventoryManagement`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `Token ${window.localStorage.getItem("token")}`,
          },
          body: JSON.stringify(body),
        },
      );

      if (inventoryResponse.ok) {
        const responseData = await inventoryResponse.json();
        const newInventory = responseData.inventory;
        notification.success({ message: responseData.message });

        // Add to inventories list for BDF
        const inventoryToAdd = {
          ...newInventory,
          codeNo: newInventory.CodeNo,
          location: newInventory?.locations?.name,
          width: newInventory.width,
          height: newInventory.height,
          Bookings: newInventory.Bookings || [],
          rpm: newInventory.ratePerMonth,
          Illu: newInventory.Illu,
          unit: newInventory?.unit || 1,
          mountingCharge: generateMC(
            newInventory.width,
            newInventory.height,
            newInventory.Illu,
            newInventory?.unit,
            newInventory?.typeOfMedia?.name,
          ),
          printingCharge: generatePC(
            newInventory.width,
            newInventory.height,
            newInventory.Illu,
            newInventory?.unit,
            newInventory?.typeOfMedia?.name,
          ),
          specialRatePerMonth: newInventory.ratePerMonth,
          ratePerMonth: newInventory.ratePerMonth,
          checked: false,
        };

        setInventories([
          ...inventories,
          withBdfLineKey(enrichBdfInventoryFromRedux(inventoryToAdd, reduxInvs)),
        ]);
        setAddInventoryBoolean(false);
        form.resetFields();
        setSelectedImage(null);
        setImageUrl(null);
        setSelectedFiles([]);
        setPreviewURLs([]);
        setFlag(false);
      } else {
        const responseData = await inventoryResponse.json();

        if (responseData.error) {
          notification.error({ message: responseData.error });
        }
        // Do not add to frontend when API returned error (e.g. Inventory already exists)
        setAddInventoryBoolean(false);
        form.resetFields();
        setSelectedImage(null);
        setImageUrl(null);
        setSelectedFiles([]);
        setPreviewURLs([]);
        setFlag(false);
      }
    } catch (error) {
      console.log("Error during inventory insertion:", error.message);
      notification.error({
        message: "Error adding inventory. Please try again.",
      });
    }
  };

  const onFinish = async (values) => {
    let data = {
      locations: {
        city: values.city,
        Area: values.area,
        name: values.name,
      },
      Illu: values.illu,
      width: values.width,
      height: values.height,
      CodeNo: values.codeNo,
      CASCode: values.casCode,
      typeOfMedia: values.mediaType,
      img: imageUrl,
      vendor: values.vendor,
      ownedBy: values.vendor,
      ratePerMonth: values.ratePerMonth,
      lat: values.lat,
      lng: values.lng,
      PurchaseRate: values.PurchaseRate,
      isTrading: true,
      suffix: values.suffix,
    };
    await addSingleTradingInventory(data);
  };

  useEffect(() => {
    let ids = inventories?.map((ele) => ele?.codeNo);
    setCartCodeNos([...ids]);
  }, [inventories]);

  const bdfType =
    activeTabInner ?? bdfData?.bdfType ?? bdfData?.getTypeOfBDF;
  const allowDuplicateInventories = bdfType === "F" || bdfType === "R";

  useEffect(() => {
    if (!inventories?.length) return;
    const lineKeys = inventories.map(getBdfLineKey);
    if (lineKeys.length !== new Set(lineKeys).size) {
      setInventories(ensureUniqueBdfLineKeys(inventories));
    }
  }, [inventories, setInventories]);

  useEffect(() => {
    if (!inventories?.length || !reduxInvs?.length) return;
    setInventories((prev) => {
      const enriched = prev.map((item) =>
        enrichBdfInventoryFromRedux(item, reduxInvs),
      );
      const changed = prev.some(
        (item, i) =>
          item.blockedDates !== enriched[i].blockedDates ||
          item.premiumBlock !== enriched[i].premiumBlock,
      );
      return changed ? enriched : prev;
    });
  }, [reduxInvs]);

  useEffect(() => {
    const filteredInventories = allowDuplicateInventories
      ? reduxInvs
      : reduxInvs.filter(
          (itemB) => !inventories?.some((itemA) => itemA?._id === itemB._id),
        );
    const muchFilteredData = filteredInventories.map((ele) => {
      return {
        _id: ele._id,
        codeNo: ele.CodeNo,
        location: ele.locations.name,
        width: ele.width,
        height: ele.height,
        Bookings: ele.Bookings,
        blockedDates: ele?.blockedDates,
        premiumBlock: ele?.premiumBlock,
        rpm: ele.ratePerMonth,
        Illu: ele.Illu,
        isOverlapPossible: ele?.isOverlapPossible,
        isArchived: ele?.isArchived,
        removedOn: ele?.removedOn,
        typeOfMedia: ele?.typeOfMedia,
        mountingCharge: generateMC(
          ele.width,
          ele.height,
          ele.Illu,
          ele?.unit,
          ele?.typeOfMedia?.name,
        ),
        printingCharge: generatePC(
          ele.width,
          ele.height,
          ele.Illu,
          ele?.unit,
          ele?.typeOfMedia?.name,
        ),
        specialRate: ele.ratePerMonth,
        ratePerMonth: ele.ratePerMonth,
        checked: false,
      };
    });

    setAllInv(muchFilteredData);
    setAllInvD(muchFilteredData);
  }, [reduxInvs, inventories, allowDuplicateInventories]);

  // Fetch sub-BDF IDs when editing a BDF
  useEffect(() => {
    const fetchSubBDFIds = async () => {
      if (id && id !== "direct-bdf") {
        try {
          const response = await fetch(
            `${apiBaseUrl}/inventoryManagement/getAllSubBDFs?bdfId=${id}`,
            {
              method: "GET",
              credentials: "include",
              headers: {
                "Content-Type": "application/json",
              },
            },
          );
          const responseData = await response.json();
          if (response.ok && responseData.success) {
            setSubBDFIds(responseData.subBDFIds || []);
          }
        } catch (error) {
          console.error("Error fetching sub-BDF IDs:", error);
        }
      }
    };

    fetchSubBDFIds();
  }, [id]);

  //specially changes if package Rate exists
  // useEffect(() => {
  //   if (packageRate) {
  //     let totalRpmWeight = inventories.reduce((acc, next) => {
  //       return acc + Number(next?.ratePerMonth);
  //     }, 0);
  //     function weightage(val) {
  //       let res = Number(packageRate) * (Number(val) / Number(totalRpmWeight));
  //       return Math.floor(res);
  //     }

  //     let updatedData = inventories?.map((ele) => ({
  //       ...ele,
  //       mountingCharge: 0,
  //       printingCharge: 0,
  //       specialRatePerMonth: weightage(ele.ratePerMonth),
  //     }));
  //     let updatedData2 = updatedData?.map((ele) => ({
  //       ...ele,
  //       mountingCharge: 0,
  //       printingCharge: 0,
  //       specialRate:
  //         MonthToDurationRate(ele, ele.startDate, ele.endDate).newSpecialRate ||
  //         0,
  //     }));

  //     setInventories(updatedData2);
  //   }
  // }, [packageRate]);

  // useEffect(() => {
  //   if (packageRate && inventories.length > 0) {
  //     // 1. Get raw monthly values
  //     const inventoryValues = inventories.map(
  //       (inv) => Number(inv.specialRate) || 0
  //     );
  //     const totalSum = inventoryValues.reduce((acc, val) => acc + val, 0);

  //     // 2. Apply correct scaling logic
  //     const scaledRates = calculateScaledRates(
  //       inventoryValues,
  //       packageRate,
  //       totalSum
  //     );

  //     // 3. Set scaled value directly in specialRate
  //     const updatedInventories = inventories.map((item, index) => {
  //       const scaledValue = scaledRates[index]; // this is the final value you want saved

  //       return {
  //         ...item,
  //         specialRate: scaledValue, // Save this directly
  //         mountingCharge: 0,
  //         printingCharge: 0,
  //         // optional: keep specialRatePerMonth if needed for UI reference
  //       };
  //     });

  //     setInventories(updatedInventories);
  //   }
  // }, [packageRate, inventories?.length]);

  useEffect(() => {
    if (packageRate && inventories.length > 0) {
      // Calculate scaled rates using our function
      const scaledRates = calculateScaledRates(inventories, packageRate);

      // Calculate distributed printing and mounting charges
      const printingCharges =
        includePrintingCharge && printingCost > 0
          ? distributeCost(printingCost, inventories.length)
          : Array(inventories.length).fill(0);

      const mountingCharges =
        includeMountingCharge && mountingCost > 0
          ? distributeCost(mountingCost, inventories.length)
          : Array(inventories.length).fill(0);

      // Update inventories without causing a circular update
      setInventories((prevInvs) => {
        const updatedInventories = inventories.map((item, index) => {
          return {
            ...item,
            specialRate: scaledRates[index],
            _actualPrintingCharge: printingCharges[index],
            _actualMountingCharge: mountingCharges[index],
            printingCharge: 0,
            mountingCharge: 0,
          };
        });

        // Only update if something actually changed
        if (JSON.stringify(prevInvs) !== JSON.stringify(updatedInventories)) {
          return updatedInventories;
        }
        return prevInvs;
      });
    }
  }, [
    packageRate,
    printingCost,
    mountingCost,
    includePrintingCharge,
    includeMountingCharge,
  ]);

  // Add this new initialization useEffect that only runs once
  // Updated initialization useEffect that only enables checkboxes when there are actual charges
  useEffect(() => {
    if (inventories && inventories.length > 0 && !didInitialize.current) {
      didInitialize.current = true;

      // Calculate the total printing cost across all inventories
      const totalPrintingCost = inventories.reduce((sum, item) => {
        const charge =
          item._actualPrintingCharge && item._actualPrintingCharge > 0
            ? item._actualPrintingCharge
            : item.printingCharge || 0;
        return sum + charge;
      }, 0);

      // Calculate the total mounting cost across all inventories
      const totalMountingCost = inventories.reduce((sum, item) => {
        const charge =
          item._actualMountingCharge && item._actualMountingCharge > 0
            ? item._actualMountingCharge
            : item.mountingCharge || 0;
        return sum + charge;
      }, 0);

      // ONLY set the include checkboxes AND costs if the total is actually greater than zero
      if (totalPrintingCost > 0) {
        setIncludePrintingCharge(true);
        setPrintingCost(totalPrintingCost);
      } else {
        setIncludePrintingCharge(false);
        setPrintingCost(0);
      }

      if (totalMountingCost > 0) {
        setIncludeMountingCharge(true);
        setMountingCost(totalMountingCost);
      } else {
        setIncludeMountingCharge(false);
        setMountingCost(0);
      }
    }
  }, [inventories]); // Only depend on inventories

  const mapExistingInvForPicker = (ele, fallbackIsTrading = false) => ({
    _id: ele._id,
    codeNo: ele.CodeNo,
    location: ele.locations?.name,
    width: ele.width,
    height: ele.height,
    Bookings: ele.Bookings || [],
    blockedDates: ele?.blockedDates,
    premiumBlock: ele?.premiumBlock,
    rpm: ele.ratePerMonth,
    Illu: ele.Illu,
    unit: ele?.unit || 1,
    isTrading: ele?.isTrading ?? fallbackIsTrading,
    isArchived: ele?.isArchived,
    removedOn: ele?.removedOn,
    isOverlapPossible: ele?.isOverlapPossible,
    typeOfMedia: ele?.typeOfMedia,
    ownedBy: ele?.ownedBy,
    mountingCharge: generateMC(
      ele.width,
      ele.height,
      ele.Illu,
      ele?.unit,
      ele?.typeOfMedia?.name,
    ),
    printingCharge: generatePC(
      ele.width,
      ele.height,
      ele.Illu,
      ele?.unit,
      ele?.typeOfMedia?.name,
    ),
    specialRate: ele.ratePerMonth,
    specialRatePerMonth: ele.ratePerMonth,
    ratePerMonth: ele.ratePerMonth,
    checked: false,
  });

  const mapTradingInvForPicker = (ele) => mapExistingInvForPicker(ele, true);
  const mapRemovedInvForPicker = (ele) => mapExistingInvForPicker(ele, false);

  const displayTradingInvs = async () => {
    setInventoryPickerType("trading");
    setLoadingTradingInvs(true);
    try {
      const response = await fetch(
        `${apiBaseUrl}/inventoryManagement/getAllTradingInventories`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: `Token ${window.localStorage.getItem("token")}`,
          },
        },
      );
      const data = await response.json();
      if (!data.success) {
        notification.error({
          message: data.error || "Failed to fetch trading inventories.",
        });
        return;
      }
      const filteredInventories = allowDuplicateInventories
        ? data.allTradingInventories || []
        : (data.allTradingInventories || []).filter(
            (itemB) =>
              !inventories?.some((itemA) => itemA?._id === itemB?._id),
          );
      const mapped = filteredInventories.map(mapTradingInvForPicker);
      setAllTradingInv(mapped);
      setAllTradingInvD(mapped);
      setTradingSearchText("");
      setOpenTradingInvs(true);
    } catch (error) {
      console.error("Failed to fetch trading inventories:", error);
      notification.error({
        message: "Failed to load trading inventories. Please try again.",
      });
    } finally {
      setLoadingTradingInvs(false);
    }
  };

  const displayRemovedInvs = async () => {
    setInventoryPickerType("removed");
    setLoadingRemovedInvs(true);
    try {
      const response = await fetch(
        `${apiBaseUrl}/inventoryManagement/getAllRemovedInventories`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: `Token ${window.localStorage.getItem("token")}`,
          },
        },
      );
      const data = await response.json();
      if (!data.success) {
        notification.error({
          message: data.error || "Failed to fetch removed inventories.",
        });
        return;
      }
      const filteredInventories = allowDuplicateInventories
        ? data.allRemovedInventories || []
        : (data.allRemovedInventories || []).filter(
            (itemB) =>
              !inventories?.some((itemA) => itemA?._id === itemB?._id),
          );
      const mapped = filteredInventories.map(mapRemovedInvForPicker);
      setAllTradingInv(mapped);
      setAllTradingInvD(mapped);
      setTradingSearchText("");
      setOpenTradingInvs(true);
    } catch (error) {
      console.error("Failed to fetch removed inventories:", error);
      notification.error({
        message: "Failed to load removed inventories. Please try again.",
      });
    } finally {
      setLoadingRemovedInvs(false);
    }
  };

  const handleCheckboxChange = (e, record) => {
    const { checked } = e.target;
    const updatedData = allInvD.map((item) => {
      if (item._id === record._id) {
        return { ...item, checked };
      }
      return item;
    });
    setAllInvD(updatedData);
    setAllInv(filterSearch(searchText, updatedData));
  };

  const handleTradingCheckboxChange = (e, record) => {
    const { checked } = e.target;
    const updatedData = allTradingInvD.map((item) => {
      if (item._id === record._id) {
        return { ...item, checked };
      }
      return item;
    });
    setAllTradingInvD(updatedData);
    setAllTradingInv(filterSearch(tradingSearchText, updatedData));
  };

  let debounceTimer;
  const handleFilterData = (e) => {
    clearTimeout(debounceTimer);
    setSearchText(e.target.value);
    debounceTimer = setTimeout(() => {
      setAllInv(filterSearch(e.target.value, allInvD));
    }, 500); // Adjust the debounce time as needed (e.g., 300 milliseconds)
  };

  let tradingDebounceTimer;
  const handleTradingFilterData = (e) => {
    clearTimeout(tradingDebounceTimer);
    setTradingSearchText(e.target.value);
    tradingDebounceTimer = setTimeout(() => {
      setAllTradingInv(filterSearch(e.target.value, allTradingInvD));
    }, 500);
  };
  function handleDelete(lineKey) {
    if (inventories.length == 1) {
      notification.error({ message: "Cant Keep the Inventory List Empty!" });
    } else {
      setInventories((prev) => {
        let filteredData = prev.filter((ele) => getBdfLineKey(ele) !== lineKey);
        return filteredData;
      });
    }
  }
  const MonthToDurationRate = (ele, startDateStr, endDateStr) => {
    // Strict DD-MM-YYYY parse so duration matches across months (customParseFormat extended at top)
    const startDayjs = dayjs(startDateStr, "DD-MM-YYYY", true);
    const endDayjs = dayjs(endDateStr, "DD-MM-YYYY", true);

    if (!startDayjs.isValid() || !endDayjs.isValid()) {
      console.error("Invalid start or end date passed to MonthToDurationRate");
      return { newSpecialRate: 0, discount: 0 };
    }

    // Inclusive day count — same span must yield same count regardless of start month
    const differenceInDays = endDayjs.diff(startDayjs, "day") + 1;
    if (differenceInDays < 1) {
      return { newSpecialRate: 0, discount: 0 };
    }

    const monthsDiff = endDayjs.diff(startDayjs, "month", true); // Get exact months as decimal

    // Check if it's a full month period (start day = 1 and end day = last day of month)
    const isStartFirstDay = startDayjs.date() === 1;
    const isEndLastDay = endDayjs.date() === endDayjs.daysInMonth();

    // Check if it represents whole months by comparing the month difference
    const roundedMonthsDiff = Math.round(monthsDiff);
    const isWholeMonthPeriod =
      Math.abs(monthsDiff - roundedMonthsDiff) < 0.1 && roundedMonthsDiff >= 1;

    // Calculate expected days for the rounded months to determine tolerance
    const calculateExpectedDays = (months) => {
      let expectedDays = 0;
      let currentMonth = startDayjs;

      for (let i = 0; i < months; i++) {
        expectedDays += currentMonth.daysInMonth();
        currentMonth = currentMonth.add(1, "month");
      }

      return expectedDays;
    };

    const expectedDaysForRoundedMonths =
      calculateExpectedDays(roundedMonthsDiff);
    const maxExtraDays = Math.min(
      6,
      Math.ceil(expectedDaysForRoundedMonths * 0.1),
    ); // Max 10% extra or 6 days, whichever is smaller

    // For periods that are clearly meant to be whole months, be more generous with tolerance
    const isClearWholeMonthPeriod =
      roundedMonthsDiff >= 2 &&
      Math.abs(monthsDiff - roundedMonthsDiff) <= 0.15; // Within 0.15 months of whole number

    const adjustedMaxExtraDays = isClearWholeMonthPeriod
      ? Math.max(maxExtraDays, 3)
      : maxExtraDays; // At least 3 days tolerance for clear whole months

    // Special handling for periods that are very close to whole months (like 181 days for 6 months)
    const isVeryCloseToWholeMonths =
      roundedMonthsDiff >= 2 &&
      Math.abs(monthsDiff - roundedMonthsDiff) <= 0.25 && // More generous threshold
      differenceInDays >= expectedDaysForRoundedMonths - 4 && // Allow up to 4 days less
      differenceInDays <= expectedDaysForRoundedMonths; // But not more than expected

    // Dynamic handling for any month period with reasonable day tolerance
    const isDynamicMonthPeriod =
      roundedMonthsDiff >= 2 &&
      differenceInDays >= expectedDaysForRoundedMonths - 4 &&
      differenceInDays <= expectedDaysForRoundedMonths;

    // Calculate dynamic tolerance based on actual months involved
    const calculateDynamicTolerance = (months) => {
      let minDays = 0;
      let maxDays = 0;
      let currentMonth = startDayjs;

      // Calculate minimum days (assuming shortest possible months)
      for (let i = 0; i < months; i++) {
        minDays += 28; // Minimum days in any month
        currentMonth = currentMonth.add(1, "month");
      }

      // Reset and calculate maximum days (assuming longest possible months)
      currentMonth = startDayjs;
      for (let i = 0; i < months; i++) {
        maxDays += 31; // Maximum days in any month
        currentMonth = currentMonth.add(1, "month");
      }

      return { minDays, maxDays };
    };

    const tolerance = calculateDynamicTolerance(roundedMonthsDiff);
    const isDynamicMonthPeriodWithTolerance =
      roundedMonthsDiff >= 2 &&
      differenceInDays >= tolerance.minDays &&
      differenceInDays <= tolerance.maxDays;

    // Additional check: ensure it's not just a short period that happens to round to a whole number
    const isActuallyWholeMonths =
      isWholeMonthPeriod &&
      // Case 1: Full month periods (1st to last day)
      ((isStartFirstDay && isEndLastDay) ||
        // Case 2: Same day of month (e.g., 15th to 15th)
        startDayjs.date() === endDayjs.date() ||
        // Case 3: End day is one day before start day (e.g., 14th to 13th)
        endDayjs.date() === startDayjs.date() - 1 ||
        // Case 4: Periods that span multiple months and are close to whole months
        (roundedMonthsDiff >= 2 &&
          Math.abs(monthsDiff - roundedMonthsDiff) < 0.05) ||
        // Case 5: Multi-month periods with dynamic extra days tolerance (only allow fewer days, not more)
        (roundedMonthsDiff >= 2 &&
          Math.abs(monthsDiff - roundedMonthsDiff) <= 0.2 &&
          differenceInDays >=
          expectedDaysForRoundedMonths - adjustedMaxExtraDays &&
          differenceInDays <= expectedDaysForRoundedMonths) ||
        // Case 6: Very close to whole months (special handling for edge cases like 181 days)
        isVeryCloseToWholeMonths ||
        // Case 7: Dynamic handling for any month period with reasonable day tolerance
        isDynamicMonthPeriod ||
        // Case 8: Dynamic handling with actual month tolerance (28-31 days per month)
        isDynamicMonthPeriodWithTolerance);

    let newSpecialRate = 0;
    let discount = 0;

    // Calculate based on actual days for accurate pricing
    const daysInStartMonth = startDayjs.daysInMonth();
    const dailyRate = ele?.specialRatePerMonth / daysInStartMonth;
    const isFebruary = startDayjs.month() === 1; // February is month index 1

    // For full month periods (start day = 1 and end day = last day of month), use simple multiplication
    if (isStartFirstDay && isEndLastDay) {
      const fullMonths = Math.round(monthsDiff);
      newSpecialRate = ele?.specialRatePerMonth * fullMonths;
    } else if (isActuallyWholeMonths) {
      // If it represents actual whole months (1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12 months), use simple multiplication
      newSpecialRate = ele?.specialRatePerMonth * roundedMonthsDiff;
    } else if (differenceInDays % 30 === 0) {
      // If duration is multiple of 30 days, count as full months (30=1month, 60=2months, 90=3months, etc.)
      const fullMonths = differenceInDays / 30;
      newSpecialRate = ele?.specialRatePerMonth * fullMonths;
    } else if (isStartFirstDay && monthsDiff >= 1) {
      // If starts on 1st of month and spans multiple months, calculate based on 30-day months
      const fullMonths = Math.floor(monthsDiff);
      const remainingDays = differenceInDays - fullMonths * 30;
      newSpecialRate =
        ele?.specialRatePerMonth * fullMonths + remainingDays * dailyRate;
    } else if (
      isFebruary &&
      (differenceInDays === 27 ||
        differenceInDays === 28 ||
        differenceInDays === 29)
    ) {
      // For February, treat 27/28/29 days as full month
      newSpecialRate = ele?.specialRatePerMonth;
    } else {
      // Prorate by inclusive days using fixed 30-day month (same convention as
      // calculatePurchaseRate) so identical day spans always give the same amount
      // regardless of whether the range starts in May (31) vs June (30), etc.
      newSpecialRate = Math.round(
        (ele?.specialRatePerMonth / 30) * differenceInDays,
      );
    }

    // Calculate discount
    const perDayRpm = ele?.ratePerMonth / daysInStartMonth;
    const srPerDay = ele?.specialRatePerMonth / daysInStartMonth;
    discount = Math.floor(Number(100 - (srPerDay * 100) / perDayRpm));

    return { newSpecialRate: Math.floor(newSpecialRate), discount };
  };
  const handleEdit = (value, lineKey, field) => {
    setInventories((prev) => {
      const index = prev.findIndex((item) => getBdfLineKey(item) === lineKey);
      if (index === -1) return prev; // Handle case where ID is not found

      const updatedInventories = [...prev];
      const inventory = updatedInventories[index];
      const updatedInventory = { ...inventory };

      if (field === "specialRatePerMonth") {
        updatedInventory[field] = Number(value);
        if (inventory.startDate && inventory.endDate) {
          let { newSpecialRate, discount } = MonthToDurationRate(
            updatedInventory,
            inventory.startDate,
            inventory.endDate,
          );
          updatedInventory.specialRate = newSpecialRate || 0;
          updatedInventory.discount = discount;
        }
      } else {
        updatedInventory[field] = Number(value);
      }

      updatedInventories[index] = updatedInventory;
      return updatedInventories;
    });
  };
  // const handleDateRangeChange = (dates, dateStrings, id) => {

  // };
  const isRangeValid = (startDate, endDate, blockedRanges) => {
    const start = moment(startDate).format("YYYY-MM-DD");
    const end = moment(endDate).format("YYYY-MM-DD");
    const today = moment().startOf("day").format("YYYY-MM-DD");

    // Ensure the start date is not in the past
    if (start < today) return false;

    // Ensure the selected range does not overlap with blocked ranges
    let status = (blockedRanges || []).some(
      ({ startDate: blockStart, endDate: blockEnd }) => {
        if (!blockStart || !blockEnd) {
          return true;
        } else {
          const blockStartStr = moment(blockStart).format("YYYY-MM-DD");
          const blockEndStr = moment(blockEnd).format("YYYY-MM-DD");
          console.log("start >= blockStartStr", start >= blockStartStr);
          console.log("end >= blockStartStr", end >= blockStartStr);
          console.log(
            "start <= blockStartStr",
            start <= blockStartStr,
            start,
            blockStartStr,
          );
          console.log(
            "end <= blockEndStr",
            end <= blockEndStr,
            end,
            blockEndStr,
          );
          console.log(
            "amigos well this is the truth",
            (start >= blockStartStr && end >= blockStartStr) ||
            (start <= blockStartStr && end <= blockEndStr),
          );

          return (
            (start >= blockStartStr && end >= blockStartStr) ||
            (start <= blockStartStr && end <= blockEndStr)
          );
        }
      },
    );
    return status;
  };
  // const handleDateRangeChange = (dates, dateStrings, recordId) => {
  //   if (
  //     !dates ||
  //     dates.length !== 2 ||
  //     !dateStrings ||
  //     dateStrings.length !== 2
  //   ) {
  //     console.error("Invalid date range selected");
  //     return; // Exit if dates are invalid
  //   }

  //   const [startDateObj, endDateObj] = dates;

  //   const formattedStart = startDateObj.format("DD-MM-YYYY");
  //   const formattedEnd = endDateObj.format("DD-MM-YYYY");

  //   setInventories((prev) => {
  //     const index = prev.findIndex((item) => item._id === recordId);
  //     if (index === -1) return prev; // Handle case where ID is not found

  //     const updatedInventories = [...prev];
  //     const inventory = updatedInventories[index];

  //     const { newSpecialRate, discount } = MonthToDurationRate(
  //       inventory,
  //       formattedStart,
  //       formattedEnd
  //     );

  //     updatedInventories[index] = {
  //       ...inventory,
  //       startDate: formattedStart,
  //       endDate: formattedEnd,
  //       specialRate: newSpecialRate || 0,
  //       discount: discount,
  //     };

  //     return updatedInventories;
  //   });

  //   // Calculate campaignDuration if all items have valid endDates
  //   setInventories((prev) => {
  //     const updatedData = [...prev];

  //     const allHaveEndDates = updatedData.every((item) => item.endDate);
  //     if (allHaveEndDates) {
  //       let maxDifferenceInDays = 0;

  //       updatedData.forEach((item) => {
  //         if (item.startDate && item.endDate) {
  //           // const differenceInMilliseconds =
  //           //   new Date(item.endDate) - new Date(item.startDate);
  //           // const differenceInDays =
  //           //   differenceInMilliseconds / (1000 * 3600 * 24); // Convert to days
  //           // maxDifferenceInDays = Math.max(
  //           //   maxDifferenceInDays,
  //           //   differenceInDays
  //           // );
  //           const start = dayjs(item.startDate, "DD-MM-YYYY");
  //           const end = dayjs(item.endDate, "DD-MM-YYYY");

  //           if (start.isValid() && end.isValid()) {
  //             const differenceInDays = end.diff(start, "day");
  //             maxDifferenceInDays = Math.max(
  //               maxDifferenceInDays,
  //               differenceInDays
  //             );
  //           }
  //         }
  //       });

  //       handleChange("campaignDuration", maxDifferenceInDays + 1); // Add 1 to include both dates
  //     }

  //     return updatedData;
  //   });
  // };

  const handleDateRangeChange = (dates, dateStrings, lineKey) => {
    if (
      !dates ||
      dates.length !== 2 ||
      !dateStrings ||
      dateStrings.length !== 2
    ) {
      console.error("Invalid date range selected");
      return; // Exit if dates are invalid
    }

    const [startDateObj, endDateObj] = dates;

    const formattedStart = startDateObj.format("DD-MM-YYYY");
    const formattedEnd = endDateObj.format("DD-MM-YYYY");

    setInventories((prev) => {
      const index = prev.findIndex((item) => getBdfLineKey(item) === lineKey);
      if (index === -1) return prev; // Handle case where ID is not found

      const updatedInventories = [...prev];
      const inventory = updatedInventories[index];

      if (
        allowDuplicateInventories &&
        hasOverlapWithSiblingBdfLines(
          prev,
          lineKey,
          inventory._id,
          formattedStart,
          formattedEnd,
        )
      ) {
        notification.error({
          message:
            "This booking period overlaps with another period already selected for the same inventory on this BDF.",
        });
        return prev;
      }

      // Update dates first
      updatedInventories[index] = {
        ...inventory,
        startDate: formattedStart,
        endDate: formattedEnd,
      };

      // If we have a package rate, recalculate all special rates
      if (packageRate) {
        const scaledRates = calculateScaledRates(
          updatedInventories,
          packageRate,
        );

        // Calculate distributed printing and mounting charges
        const printingCharges =
          includePrintingCharge && printingCost > 0
            ? distributeCost(printingCost, updatedInventories.length)
            : Array(updatedInventories.length).fill(0);

        const mountingCharges =
          includeMountingCharge && mountingCost > 0
            ? distributeCost(mountingCost, updatedInventories.length)
            : Array(updatedInventories.length).fill(0);

        // Update all inventory items with their new scaled rates
        return updatedInventories.map((item, idx) => ({
          ...item,
          specialRate: scaledRates[idx],
          // Store the actual charges internally
          _actualPrintingCharge: printingCharges[idx],
          _actualMountingCharge: mountingCharges[idx],
          // Keep UI showing 0
          printingCharge: 0,
          mountingCharge: 0,
        }));
      } else {
        // Original logic for when no package rate exists
        const { newSpecialRate, discount } = MonthToDurationRate(
          inventory,
          formattedStart,
          formattedEnd,
        );

        updatedInventories[index] = {
          ...updatedInventories[index],
          specialRate: newSpecialRate || 0,
          discount: discount,
          // Clear the internal storage when not using package rate
          _actualPrintingCharge: undefined,
          _actualMountingCharge: undefined,
        };

        return updatedInventories;
      }
    });

    // Calculate campaignDuration if all items have valid endDates
    setInventories((prev) => {
      const updatedData = [...prev];

      const allHaveEndDates = updatedData.every((item) => item.endDate);
      if (allHaveEndDates) {
        let maxDifferenceInDays = 0;

        updatedData.forEach((item) => {
          if (item.startDate && item.endDate) {
            const start = dayjs(item.startDate, "DD-MM-YYYY");
            const end = dayjs(item.endDate, "DD-MM-YYYY");

            if (start.isValid() && end.isValid()) {
              const differenceInDays = end.diff(start, "day");
              maxDifferenceInDays = Math.max(
                maxDifferenceInDays,
                differenceInDays,
              );
            }
          }
        });

        handleChange("campaignDuration", maxDifferenceInDays + 1); // Add 1 to include both dates
      }

      return updatedData;
    });
  };

  // Helper function to distribute costs evenly with proper rounding
  const distributeCost = (totalCost, itemCount) => {
    if (totalCost === 0 || itemCount === 0) return Array(itemCount).fill(0);

    const baseAmount = Math.floor(totalCost / itemCount);
    const remainder = totalCost - baseAmount * itemCount;

    // Create array with base amount for all items
    const distribution = Array(itemCount).fill(baseAmount);

    // Distribute the remainder by adding 1 to the first 'remainder' items
    for (let i = 0; i < remainder; i++) {
      distribution[i] += 1;
    }

    return distribution;
  };

  const getRemovedOnDateString = (record) => {
    if (!record?.removedOn) return null;
    const removedOn = moment(record.removedOn);
    return removedOn.isValid() ? removedOn.format("YYYY-MM-DD") : null;
  };

  const isDateAfterRemovedOn = (currentDate, record) => {
    const removedOn = getRemovedOnDateString(record);
    if (!removedOn) return false;
    return currentDate.format("YYYY-MM-DD") > removedOn;
  };

  const getRemovedOnLabel = (record) => {
    if (!record?.removedOn) return "";
    const removedOn = moment(record.removedOn);
    return removedOn.isValid() ? removedOn.format("DD-MM-YYYY") : "";
  };

  const isDateBlocked = (
    currentDate,
    blockedRanges,
    blockedDates,
    premiumBlock,
    record,
    { blockSiblingPeriods = false, inventories: invListForSiblingBlock } = {},
  ) => {
    if (!currentDate) return false;

    if (isDateAfterRemovedOn(currentDate, record)) return true;

    // Allow overlapping dates for inventories where overlap is explicitly allowed
    if (record?.isOverlapPossible) return false;

    // let br = blockedRanges.filter((ele) => ele?.bdfId != bdfId);
    const dateString = currentDate.format("YYYY-MM-DD");

    if (
      blockSiblingPeriods &&
      record?._id &&
      isDateBlockedBySiblingBdfLines(
        dateString,
        invListForSiblingBlock,
        getBdfLineKey(record),
        record._id,
      )
    ) {
      return true;
    }
    // const today = moment().startOf("day").format("YYYY-MM-DD");
    // Block dates in the past
    // if (dateString < today) return true;
    const isBookingBlocked = (blockedRanges || []).some(
      ({ startDate, endDate, bdfId }) => {
        // Exclude current BDF and all its sub-BDFs
        if (bdfId === id || subBDFIds.includes(bdfId)) return false;

        const start = moment(startDate).format("YYYY-MM-DD");
        const end = moment(endDate).format("YYYY-MM-DD");
        return dateString >= start && dateString <= end;
      },
    );

    // Any blocked-dates doc with a range (not only premium / management)
    const isBlockedByInventoryBlock = blockedDates?.some((block) => {
      if (
        !block?.blockedAt ||
        !block?.blockedTill ||
        block.archived === true
      ) {
        return false;
      }
      const start = moment(block.blockedAt).format("YYYY-MM-DD");
      const end = moment(block.blockedTill).format("YYYY-MM-DD");
      return dateString >= start && dateString <= end;
    });

    //Check if we have fullId to check
    let isFullBlocked;
    if (record.fullId) {
      isFullBlocked = record?.fullId?.Bookings?.some(
        ({ startDate, endDate }) => {
          const start = moment(startDate).format("YYYY-MM-DD");
          const end = moment(endDate).format("YYYY-MM-DD");
          return dateString >= start && dateString <= end;
        },
      );
    }
    //Check if we have half1Id to check
    let isHalf1Blocked;
    if (record.half1Id) {
      isHalf1Blocked = record?.half1Id?.Bookings?.some(
        ({ startDate, endDate }) => {
          const start = moment(startDate).format("YYYY-MM-DD");
          const end = moment(endDate).format("YYYY-MM-DD");
          return dateString >= start && dateString <= end;
        },
      );
    }
    //Check if we have half1Id to check
    let isHalf2Blocked;
    if (record.half2Id) {
      isHalf2Blocked = record?.half2Id?.Bookings?.some(
        ({ startDate, endDate }) => {
          const start = moment(startDate).format("YYYY-MM-DD");
          const end = moment(endDate).format("YYYY-MM-DD");
          return dateString >= start && dateString <= end;
        },
      );
    }
    const isPremiumBlocked = premiumBlock?.some(({ startDate, endDate }) => {
      const start = moment(startDate).format("YYYY-MM-DD");
      const end = moment(endDate).format("YYYY-MM-DD");
      return dateString >= start && dateString <= end;
    });

    return (
      isBookingBlocked ||
      isBlockedByInventoryBlock ||
      isPremiumBlocked ||
      isFullBlocked ||
      isHalf1Blocked ||
      isHalf2Blocked
    );
  };

  const components = {
    header: {
      cell: (props) => (
        <th
          {...props}
          style={{
            ...props.style,
            backgroundColor: "#daeffe",
          }}
        />
      ),
    },
  };

  const calculateMonthWiseSpecialRate = (
    ratePerMonth,
    specialRate,
    startDate,
    endDate,
  ) => {
    const start = new Date(startDate);
    const end = new Date(endDate);

    // Get the total number of days in the booking period
    const totalDays = Math.ceil((end - start) / (1000 * 60 * 60 * 24));

    const perDayRateRPM = ratePerMonth / 30;
    const perDayRaTeSpecial = specialRate / totalDays;
    const discount = 100 - (perDayRaTeSpecial * 100) / perDayRateRPM;

    const monthWiseSpecialRate = ((100 - discount) * ratePerMonth) / 100;
    return parseFloat(monthWiseSpecialRate.toFixed(0));
  };
  const calculateDiscount = (ratePerMonth, specialRate, startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);

    // Get the total number of days in the booking period
    const totalDays = Math.ceil((end - start) / (1000 * 60 * 60 * 24));
    const perDayRateRPM = ratePerMonth / 30;
    const perDayRaTeSpecial = specialRate / totalDays;
    let discount = 100 - (perDayRaTeSpecial * 100) / perDayRateRPM;
    if (discount < 0) {
      discount = 0;
      return discount;
    }
    return discount.toFixed(0);
  };

  // Fixed calculateScaledRates to avoid NaN values
  const calculateScaledRates = (inventories, targetRate) => {
    // Handle edge cases
    if (
      !inventories ||
      !Array.isArray(inventories) ||
      inventories.length === 0
    ) {
      return [];
    }

    if (!targetRate || isNaN(targetRate) || targetRate <= 0) {
      return Array(inventories.length).fill(0);
    }

    // Calculate purchase rate for each inventory item
    const purchaseRates = inventories.map((item) => {
      const rate = calculatePurchaseRate(item);
      return isNaN(rate) ? 0 : rate; // Additional safety check
    });

    // Calculate total sum of purchase rates
    const totalSum = purchaseRates.reduce((sum, rate) => sum + rate, 0);

    // If total is zero, distribute evenly to avoid division by zero
    if (totalSum === 0) {
      const evenRate = Math.floor(targetRate / inventories.length);
      const scaledRates = Array(inventories.length).fill(evenRate);

      // Adjust the last item to account for rounding
      const difference =
        targetRate - scaledRates.reduce((sum, rate) => sum + rate, 0);
      if (scaledRates.length > 0) {
        scaledRates[scaledRates.length - 1] += difference;
      }

      return scaledRates;
    }

    // Calculate scaled rates based on proportion of purchase rates
    const scaledRates = purchaseRates.map((rate) =>
      Math.round((rate / totalSum) * targetRate),
    );

    // Adjust for rounding errors
    const difference =
      targetRate - scaledRates.reduce((sum, rate) => sum + rate, 0);

    // Add the difference to the item with the highest value
    if (difference !== 0 && scaledRates.length > 0) {
      const maxIndex = scaledRates.indexOf(Math.max(...scaledRates));
      scaledRates[maxIndex] += difference;
    }

    return scaledRates;
  };

  // Inclusive day count between DD-MM-YYYY strings (requires customParseFormat)
  const inclusiveDaysBetween = (startStr, endStr) => {
    const start = dayjs(startStr, "DD-MM-YYYY", true);
    const end = dayjs(endStr, "DD-MM-YYYY", true);
    if (!start.isValid() || !end.isValid()) return null;
    return end.diff(start, "day") + 1;
  };

  // Function to calculate purchase rate based on selected dates (aligned with BDFCreatorContainer)
  const calculatePurchaseRate = (record) => {
    // Editor: guard invalid records (Creator relies on valid table rows)
    if (
      !record ||
      typeof record.ratePerMonth !== "number" ||
      isNaN(record.ratePerMonth)
    ) {
      return 0;
    }

    const isDerivedFromMaintenanceRate =
      record.maintenanceRate !== undefined &&
      record.maintenanceRate !== null &&
      record.maintenanceRate !== 0;

    if (!isDerivedFromMaintenanceRate) {
      const baseRate = record.ratePerMonth * 0.5;

      if (!record.startDate || !record.endDate) {
        return baseRate;
      }

      const duration = inclusiveDaysBetween(
        record.startDate,
        record.endDate,
      );
      if (duration == null || duration < 1) {
        return baseRate;
      }

      if ([28, 29, 30, 31].includes(duration)) {
        return baseRate;
      }

      return Math.round((baseRate / 30) * duration);
    }

    if (record.startDate && record.endDate) {
      const duration = inclusiveDaysBetween(
        record.startDate,
        record.endDate,
      );
      if (duration == null || duration < 1) {
        return record.maintenanceRate;
      }

      if ([28, 29, 30, 31].includes(duration)) {
        return record.maintenanceRate;
      }

      return Math.round((record.maintenanceRate / 30) * duration);
    }

    return record.maintenanceRate;
  };

  const columns = [
    {
      title: showInnovationChargeColumn ? (
        <div style={{ textAlign: "center", lineHeight: 1.2 }}>
          Location
          <br />
          Area
        </div>
      ) : (
        "Location Area"
      ),
      dataIndex: "location",
      key: "location",
      align: "center",
      width: 120,
    },
    {
      title: "RPM",
      dataIndex: "ratePerMonth",
      key: "ratePerMonth",
      align: "center",
      editable: true,
      render: (_, record) => (
        console.log("Edit record", record),
        (
          <Input
            value={record.ratePerMonth}
            disabled={true}
            onChange={(e) =>
              handleEdit(e.target.value, getBdfLineKey(record), "ratePerMonth")
            }
          />
        )
      ),
    },
    {
      title: (
        <div style={{ textAlign: "center", lineHeight: 1.2 }}>
          Printing
          <br />
          Charge
        </div>
      ),
      dataIndex: "printingCharge",
      key: "printingCharge",
      align: "center",
      editable: true,
      width: 120,
      render: (_, record) => (
        <Input
          disabled={packageRate}
          value={record.printingCharge}
          onChange={(e) =>
            handleEdit(e.target.value, getBdfLineKey(record), "printingCharge")
          }
        />
      ),
    },
    {
      title: (
        <div style={{ textAlign: "center", lineHeight: 1.2 }}>
          Mounting
          <br />
          Charge
        </div>
      ),
      dataIndex: "mountingCharge",
      key: "mountingCharge",
      align: "center",
      editable: true,
      width: 120,
      render: (_, record) => (
        <Input
          disabled={packageRate}
          value={record.mountingCharge}
          onChange={(e) =>
            handleEdit(e.target.value, getBdfLineKey(record), "mountingCharge")
          }
        />
      ),
    },
    {
      title: (
        <div style={{ textAlign: "center", lineHeight: 1.2 }}>
          Special Rate
          <br />
          Per Month
        </div>
      ),
      dataIndex: "specialRatePerMonth",
      key: "specialRatePerMonth",
      align: "center",
      editable: true,
      width: 120,
      render: (_, record) => {
        // const initialSpecialRate = calculateMonthWiseSpecialRate(
        //   record.ratePerMonth,
        //   record.specialRate,
        //   record.startDate,
        //   record.endDate
        // );
        // const isRowEdited = !!editedRows[record._id];

        return (
          <Input
            disabled={packageRate}
            value={record.specialRatePerMonth}
            onChange={(e) => {
              const value = Number(e.target.value);
              if (value > record.ratePerMonth) {
                setInfoShown(true);
              } else {
                setInfoShown(false);
              }
              setEditedRows((prev) => ({
                ...prev,
                [getBdfLineKey(record)]: true,
              }));
              handleEdit(
                e.target.value,
                getBdfLineKey(record),
                "specialRatePerMonth",
              );
            }}
          />
        );
      },
    },
    {
      title: (
        <div>
          <div>Amount</div>
          <div>(In A/C)</div>
        </div>
      ),
      dataIndex: "specialRate",
      key: "specialRate",
      align: "center",
      editable: true,
      width: 120,
      render: (_, record, index) => {
        // If packageRate exists, calculate scaled rates based on purchase rates
        if (packageRate) {
          try {
            // We'll calculate this directly here for display only
            const purchaseRates = inventories.map((item) => {
              try {
                return calculatePurchaseRate(item) || 0;
              } catch (err) {
                console.error("Error calculating purchase rate:", err);
                return 0;
              }
            });

            // Calculate total sum of purchase rates
            const totalSum = purchaseRates.reduce(
              (sum, rate) => sum + (isNaN(rate) ? 0 : rate),
              0,
            );

            if (totalSum === 0) {
              const evenRate = Math.floor(packageRate / inventories.length);
              return <Input disabled value={evenRate} />;
            }

            const scaledRate = Math.round(
              (purchaseRates[index] / totalSum) * packageRate,
            );
            return (
              <Input disabled value={isNaN(scaledRate) ? 0 : scaledRate} />
            );
          } catch (error) {
            console.error("Error rendering Special Rate:", error);
            // Fallback to even distribution
            const evenRate = Math.floor(packageRate / inventories.length);
            return <Input disabled value={evenRate} />;
          }
        }

        // Default behavior if no packageRate
        return (
          <Input
            disabled={packageRate !== null}
            value={record.specialRate}
            onChange={(e) =>
              handleEdit(e.target.value, getBdfLineKey(record), "specialRate")
            }
          />
        );
      },
    },
    {
      title: "Discount",
      dataIndex: "discount",
      key: "discount",
      align: "center",
      width: 120,
      render: (_, record) => {
        // const isRowEdited = !!editedRows[record._id];
        // console.log(record);
        // const discountValue = isRowEdited
        //   ? discountCalc(record?.specialRate, record?.ratePerMonth)
        //   : calculateDiscount(
        //       record.ratePerMonth,
        //       record.specialRate,
        //       record.startDate,
        //       record.endDate
        //     );

        return <div style={{ textAlign: "center" }}>{record?.discount}%</div>;
      },
    },
    // {
    //   title: "Suffix",
    //   dataIndex: "suffix",
    //   key: "suffix",
    //   render: (_, record) => <div style={{ textAlign: "center" }}>HO</div>,
    // },
    {
      title: "Booking Period",
      dataIndex: "bookingPeriod",
      key: "bookingPeriod",
      align: "center",
      render: (_, record) => {
        const parseDate = (date) =>
          dayjs(date, "DD-MM-YYYY", true).isValid()
            ? dayjs(date, "DD-MM-YYYY")
            : dayjs(date); // fallback to try ISO or default parsing

        const rangeValue =
          record.startDate && record.endDate
            ? [parseDate(record.startDate), parseDate(record.endDate)]
            : null;

        return (
          <div>
            {!rangeValue && record.excelDates && (
              <div
                style={{
                  fontSize: 11,
                  color: "#d48806",
                  marginBottom: 4,
                  lineHeight: 1.3,
                }}
              >
                Excel dates: {record.excelDates.startDate} →{" "}
                {record.excelDates.endDate}
                <br />
                not available, pick new dates
              </div>
            )}
            <DatePicker.RangePicker
              key={getBdfLineKey(record)}
              value={rangeValue}
              format={"DD-MM-YYYY"}
              onChange={(dates, dateStrings) =>
                handleDateRangeChange(
                  dates,
                  dateStrings,
                  getBdfLineKey(record),
                  record.Bookings,
                )
              }
              disabledDate={(currentDate) =>
                isDateBlocked(
                  currentDate,
                  record.Bookings,
                  record?.blockedDates,
                  record?.premiumBlock,
                  record,
                  {
                    blockSiblingPeriods: allowDuplicateInventories,
                    inventories,
                  },
                )
              }
              cellRender={(currentDate) => {
                const dateString = currentDate.format("YYYY-MM-DD");
                const isRemovedDateBlocked = isDateAfterRemovedOn(
                  currentDate,
                  record,
                );
                const removedOnLabel = getRemovedOnLabel(record);

                const blockedDetail = record?.isOverlapPossible
                  ? null
                  : record.blockedDates?.find((block) => {
                    if (
                      !block?.blockedAt ||
                      !block?.blockedTill ||
                      block.archived === true
                    ) {
                      return false;
                    }
                    const start = moment(block.blockedAt).format("YYYY-MM-DD");
                    const end = moment(block.blockedTill).format("YYYY-MM-DD");
                    return dateString >= start && dateString <= end;
                  });

                const premiumDetail = record?.isOverlapPossible
                  ? null
                  : record.premiumBlock?.find(({ startDate, endDate }) => {
                    const start = moment(startDate).format("YYYY-MM-DD");
                    const end = moment(endDate).format("YYYY-MM-DD");
                    return dateString >= start && dateString <= end;
                  });

                const isPremium = !!premiumDetail;
                const isBlockedDate = !!blockedDetail;
                const blockType = blockedDetail?.premiumBlock
                  ? "premium"
                  : blockedDetail?.managementBlock
                    ? "management"
                    : isBlockedDate
                      ? "normal"
                      : null;

                const blockedByName =
                  blockType === "premium"
                    ? blockedDetail?.blockedBy?.name
                    : blockType === "management"
                      ? "Management"
                      : null;
                const tooltipTitle = isRemovedDateBlocked
                  ? `Site removed on ${removedOnLabel}`
                  : isBlockedDate
                    ? blockType === "premium"
                      ? `Blocked by ${blockedByName}`
                      : blockType === "management"
                        ? `Blocked by Management`
                        : blockType === "normal"
                          ? "Blocked"
                          : ""
                    : premiumDetail
                      ? `Blocked by Premium`
                      : "";

                const cellStyles = {
                  position: "relative",
                  zIndex: 1,
                  backgroundColor: isPremium
                    ? "#bd9595"
                    : isRemovedDateBlocked
                      ? "#d9d9d9"
                    : blockType === "premium"
                      ? "#f39c12"
                      : blockType === "management"
                        ? "#d3d3d3"
                        : blockType === "normal"
                          ? "#646363"
                          : "transparent",
                  color:
                    isRemovedDateBlocked
                      ? "#8c8c8c"
                      : isPremium || blockType === "management"
                      ? "#000"
                      : isBlockedDate
                        ? "#fff"
                        : "inherit",
                  borderRadius:
                    isBlockedDate || isPremium || isRemovedDateBlocked
                      ? "50%"
                      : "0",
                  width:
                    isBlockedDate || isPremium || isRemovedDateBlocked
                      ? "25px"
                      : "auto",
                  height:
                    isBlockedDate || isPremium || isRemovedDateBlocked
                      ? "25px"
                      : "auto",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  pointerEvents: "auto",
                };

                return (
                  <Tooltip
                    title={tooltipTitle}
                    placement="top"
                  >
                    <div style={cellStyles} title={tooltipTitle}>
                      {currentDate.date()}
                    </div>
                  </Tooltip>
                );
              }}
            />
          </div>
        );
      },
    },
    {
      title: (
        <div style={{ textAlign: "center", lineHeight: 1.2 }}>
          Innovation
          <br />
          Charge
        </div>
      ),
      dataIndex: "innovationRate",
      key: "innovationRate",
      align: "center",
      editable: true,
      width: 120,

      render: (_, record) => (
        <Input
          disabled={packageRate}
          value={record.innovationRate}
          onChange={(e) =>
            handleEdit(
              Number(e.target.value),
              getBdfLineKey(record),
              "innovationRate",
            )
          }
        />
      ),
    },
    {
      title: "Action",
      dataIndex: "specialRate",
      key: "specialRate",
      align: "center",
      editable: true,
      render: (_, record) => (
        <Button onClick={() => handleDelete(getBdfLineKey(record))}>
          Delete
        </Button>
      ),
    },
  ];

  const suffixTableColumns = [
    {
      title: "Code",
      dataIndex: "suffixCode",
      key: "suffixCode",
    },
    {
      title: "Price",
      dataIndex: "specialRate",
      key: "specialRate",
    },
    {
      title: "Suffix Info",
      dataIndex: "suffixInfo",
      key: "suffixInfo",
    },
    {
      title: "Vendor",
      dataIndex: "vendor",
      key: "vendor",
    },
    {
      title: "Start date",
      dataIndex: "startDate",
      key: "startDate",
      render: (date) => (date ? dayjs(date).format("DD-MM-YYYY") : "-"),
    },
    {
      title: "End date",
      dataIndex: "endDate",
      key: "endDate",
      render: (date) => (date ? dayjs(date).format("DD-MM-YYYY") : "-"),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Button onClick={() => handleDeleteS(record)}>Delete</Button>
      ),
    },
  ];

  const columnsForInvs = [
    {
      title: "Code No.",
      dataIndex: "codeNo",
      key: "codeNo",
      render: (text, record) => {
        console.log("Record in Code No.:", record); // Logging the entire record
        return text;
      },
    },
    {
      title: "Location Area",
      dataIndex: "location",
      key: "location",
    },
    {
      title: "Width",
      dataIndex: "width",
      key: "width",
    },
    {
      title: "Height",
      dataIndex: "height",
      key: "height",
    },
    {
      title: "Illumination",
      dataIndex: "Illu",
      key: "Illu",
    },
    {
      title: "Add",
      dataIndex: "add",
      key: "add",
      render: (_, record) => (
        <Checkbox
          checked={record.checked}
          onChange={(e) => handleCheckboxChange(e, record)}
        />
      ),
    },
  ];

  const columnsForTradingInvs = columnsForInvs.map((col) => {
    if (col.key === "add") {
      return {
        ...col,
        render: (_, record) => (
          <Checkbox
            checked={record.checked}
            onChange={(e) => handleTradingCheckboxChange(e, record)}
          />
        ),
      };
    }
    if (col.key === "codeNo") {
      if (inventoryPickerType === "removed") {
        return col;
      }
      return {
        title: "Vendor",
        dataIndex: "ownedBy",
        key: "vendor",
      };
    }
    return col;
  });

  function displayInvs() {
    dispatch(getInventories());
    setToggle((prev) => !prev);
    setOpenInvs(true);
  }

  const handleOkOfTradingInv = () => {
    const selected = allTradingInv?.filter((ele) => ele.checked) || [];
    if (selected.length === 0) {
      notification.warning({ message: "Please select at least one inventory." });
      return;
    }
    if (!allowDuplicateInventories) {
      const codes = selected.map((ele) => ele.codeNo);
      const res = canAddToCart(cartCodeNos, codes);
      if (!res.canAdd) {
        notification.error({ message: res?.reason });
        return;
      }
    }
    let data;
    if (packageRate) {
      data = selected.map((ele) => ({
        ...ele,
        mountingCharge: 0,
        printingCharge: 0,
        specialRate: 0,
      }));
    } else {
      data = selected;
    }
    setOpenTradingInvs(false);
    setInventories((prev) => [
      ...prev,
      ...data.map((item) =>
        withBdfLineKey(enrichBdfInventoryFromRedux(item, reduxInvs)),
      ),
    ]);
    setTradingSearchText("");
    setAllTradingInv(null);
    setAllTradingInvD(null);
  };

  const handleCloseTradingInv = () => {
    setOpenTradingInvs(false);
    setAllTradingInv(null);
    setAllTradingInvD(null);
    setTradingSearchText("");
  };

  const handleOkOfAllInv = () => {
    if (!allowDuplicateInventories) {
      const codes = allInv
        .filter((ele) => ele.checked)
        .map((ele) => ele.codeNo);
      const res = canAddToCart(cartCodeNos, codes);
      if (!res.canAdd) {
        notification.error({ message: res?.reason });
        return;
      }
    }
    let data;
    if (packageRate) {
      data = allInv
        .filter((ele) => ele.checked)
        .map((ele) => ({
          ...ele, // Spread the existing properties
          mountingCharge: 0,
          printingCharge: 0,
          specialRate: 0,
        }));
    } else {
      data = allInv.filter((ele) => ele.checked);
    }
    setOpenInvs(false);
    setInventories((prev) => [
      ...prev,
      ...data.map((item) =>
        withBdfLineKey(enrichBdfInventoryFromRedux(item, reduxInvs)),
      ),
    ]);
    setSearchText("");
  };
  const handleCloseAllInv = () => {
    setOpenInvs(false); // Set ok state to false to close the modal
    setAllInv(null);
    setAllInvD(null);
    setSearchText("");
  };

  // ---- Import inventories from Excel (inventories already in this BDF are skipped) ----
  const {
    excelInputRef,
    excelImport,
    handleExcelFileChange,
    closeExcelImport,
    confirmExcelImport,
    downloadExcelTemplate,
    openExcelPicker,
    openExcelImport,
  } = useBdfExcelImport({
    inventories,
    setInventories,
    allowDuplicateInventories,
    packageRate,
    handleChange,
    isDateBlocked,
    calcSpecialRate: MonthToDurationRate,
    canAddToCart,
    mapRemovedInvForPicker,
    mapTradingInvForPicker,
  });

  // ---- Import trading inventories from Excel (creates the missing ones) ----
  const {
    excelInputRef: tradingExcelInputRef,
    tradingImport,
    vendors: tradingVendors,
    openTradingImport,
    closeTradingImport,
    openFilePicker: openTradingFilePicker,
    handleFileChange: handleTradingFileChange,
    setEdit: setTradingEdit,
    setEditForAll: setTradingEditForAll,
    confirmTradingImport,
    downloadTemplate: downloadTradingTemplate,
  } = useTradingExcelImport({
    inventories,
    setInventories,
    allowDuplicateInventories,
    packageRate,
    handleChange,
    isDateBlocked,
    calcSpecialRate: MonthToDurationRate,
    canAddToCart,
    mapTradingInvForPicker,
  });

  const [infoShown, setInfoShown] = useState(false);

  // Add this useEffect to enable the switch when bdfData has packageRate
  useEffect(() => {
    // If bdfData has a packageRate value, enable the switch
    if (
      bdfData?.packageRate !== undefined &&
      bdfData?.packageRate !== null &&
      bdfData?.packageRate !== 0
    ) {
      setIsPackageRateEnabled(true);
      setPackageRate(bdfData.packageRate);
    }
  }, [bdfData]);

  useEffect(() => {
    if (packageRate !== null && isPackageRateEnabled) {
      setIsPackageRateEnabled(true); // Keep ON only if user has enabled it
    }
  }, [packageRate]);

  const calculateTotalCost = () => {
    return (
      (Number(packageRate) || 0) +
      (includePrintingCharge ? Number(printingCost) || 0 : 0) +
      (includeMountingCharge ? Number(mountingCost) || 0 : 0)
    );
  };

  return (
    <>
      <div
        id="detail-type-3"
        className="Tab-content-bdf"
        style={{ padding: "1rem" }}
      >
        <>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              marginBottom: "1rem",
            }}
          >
            {/* <span>Enable Package Rate</span>
            <Switch
              style={{ marginRight: "1rem" }}
              checked={isPackageRateEnabled}
              onChange={(checked) => {
                setIsPackageRateEnabled(checked);
                setPackageRate(checked ? bdfData?.packageRate || 0 : null);
                if (!checked) {
                  setPackageRate(null);
                  handleChange("packageRate", null);
                }
              }}
            /> */}

            {isPackageRateEnabled && (
              <>
                <Checkbox
                  checked={includePrintingCharge}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    setIncludePrintingCharge(checked);
                    if (!checked) setPrintingCost(0); // Reset to 0 if unchecked
                  }}
                  style={{ marginRight: "8px" }}
                >
                  Include Printing Charge
                </Checkbox>

                <Checkbox
                  checked={includeMountingCharge}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    setIncludeMountingCharge(checked);
                    if (!checked) setMountingCost(0); // Reset to 0 if unchecked
                  }}
                  style={{ marginLeft: "12px" }}
                >
                  Include Mounting Charge
                </Checkbox>
              </>
            )}

            <div
              style={{
                marginLeft: "auto",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <span>Show Innovation Charge</span>
              <Switch
                checked={showInnovationChargeColumn}
                onChange={setShowInnovationChargeColumn}
              />
            </div>
          </div>
          {(packageRate !== null || isPackageRateEnabled) && (
            <>
              <div style={{ marginBottom: "1rem", marginTop: "2rem" }}>
                {/* Input Labels Row */}
                <div style={{ display: "flex", marginBottom: "8px" }}>
                  <div style={{ width: "22%" }}>
                    <div style={{ marginBottom: "8px" }}>Display Cost</div>
                  </div>
                  <div style={{ width: "4%" }}></div> {/* Space for + */}
                  <div style={{ width: "22%" }}>
                    <div style={{ marginBottom: "8px" }}>Printing Cost</div>
                  </div>
                  <div style={{ width: "4%" }}></div> {/* Space for + */}
                  <div style={{ width: "22%" }}>
                    <div style={{ marginBottom: "8px" }}>Mounting Cost</div>
                  </div>
                  <div style={{ width: "4%" }}></div> {/* Space for = */}
                  <div style={{ width: "22%" }}>
                    <div style={{ marginBottom: "8px" }}>
                      Total Package Rate
                    </div>
                  </div>
                </div>

                {/* Inputs and Operators Row */}
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ width: "22%" }}>
                    <Input
                      placeholder={"Enter Display Cost"}
                      value={bdfData?.packageRate}
                      onChange={(e) => {
                        handleChange(
                          "packageRate",
                          Number(e.target.value) || 0,
                        );
                        setPackageRate(Number(e.target.value) || 0);
                      }}
                    />
                  </div>

                  <div style={{ width: "4%", textAlign: "center" }}>
                    <span style={{ fontSize: "18px", fontWeight: "bold" }}>
                      +
                    </span>
                  </div>

                  <div style={{ width: "22%" }}>
                    <Input
                      placeholder="Enter Printing Cost"
                      disabled={!includePrintingCharge}
                      value={printingCost}
                      onChange={(e) =>
                        setPrintingCost(Number(e.target.value) || 0)
                      }
                    />
                  </div>

                  <div style={{ width: "4%", textAlign: "center" }}>
                    <span style={{ fontSize: "18px", fontWeight: "bold" }}>
                      +
                    </span>
                  </div>

                  <div style={{ width: "22%" }}>
                    <Input
                      placeholder="Enter Mounting Cost"
                      disabled={!includeMountingCharge}
                      value={mountingCost}
                      onChange={(e) =>
                        setMountingCost(Number(e.target.value) || 0)
                      }
                    />
                  </div>

                  <div style={{ width: "4%", textAlign: "center" }}>
                    <span style={{ fontSize: "18px", fontWeight: "bold" }}>
                      =
                    </span>
                  </div>

                  <div style={{ width: "22%" }}>
                    <Input value={calculateTotalCost()} disabled />
                  </div>
                </div>
              </div>
            </>
          )}
        </>
        {/* <Alert
          message="Table is scrollable"
          description="The table width exceeds the screen size, allowing horizontal scrolling to view all columns."
          type="info"
          closable
          style={{ marginBottom: "1rem" }}
        /> */}
        {infoShown && (
          <Alert
            message="you are exceeding the value greater then Rate per month"
            type="info"
            showIcon
            style={{ marginBottom: "1rem" }}
          />
        )}
        <div className="bdf-table">
          <Table
            tableLayout="auto"
            components={components}
            columns={
              showInnovationChargeColumn
                ? columns
                : columns.filter((col) => col.key !== "innovationRate")
            }
            dataSource={inventories
              ?.filter((item) => !item.suffixCode)
              ?.map((item) => ({
                ...enrichBdfInventoryFromRedux(item, reduxInvs),
                key: getBdfLineKey(item),
              }))}
            sticky
            scroll={{ y: 500 }}
          />
        </div>

        {/* Grand Total Card - same as BDFCreator */}
        {inventories?.filter((item) => !item.suffixCode)?.length > 0 && (
          <div
            style={{
              padding: "12px 16px",
              background:
                "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
              borderRadius: "12px",
              border: "1px solid #e2e8f0",
              boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
            }}
          >
            <div
              style={{
                fontSize: "14px",
                fontWeight: 600,
                color: "#334155",
                marginBottom: "8px",
                paddingBottom: "6px",
                borderBottom: "2px solid #cbd5e1",
              }}
            >
              Grand Total
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr",
                gap: "12px",
              }}
            >
              <div
                style={{
                  padding: "6px 12px",
                  background: "white",
                  borderRadius: "8px",
                  border: "1px solid #e2e8f0",
                  boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
                  fontSize: "14px",
                }}
              >
                <span style={{ color: "#64748b", fontWeight: 500 }}>
                  Printing Charge:{" "}
                </span>
                <span style={{ fontWeight: 700, color: "#0f172a" }}>
                  ₹{" "}
                  {(
                    inventories
                      ?.filter((item) => !item.suffixCode)
                      ?.reduce(
                        (sum, i) =>
                          sum + (Number(i?.printingCharge) || 0),
                        0
                      ) || 0
                  ).toLocaleString("en-IN")}
                </span>
              </div>
              <div
                style={{
                  padding: "6px 12px",
                  background: "white",
                  borderRadius: "8px",
                  border: "1px solid #e2e8f0",
                  boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
                  fontSize: "14px",
                }}
              >
                <span style={{ color: "#64748b", fontWeight: 500 }}>
                  Mounting Charge:{" "}
                </span>
                <span style={{ fontWeight: 700, color: "#0f172a" }}>
                  ₹{" "}
                  {(
                    inventories
                      ?.filter((item) => !item.suffixCode)
                      ?.reduce(
                        (sum, i) =>
                          sum + (Number(i?.mountingCharge) || 0),
                        0
                      ) || 0
                  ).toLocaleString("en-IN")}
                </span>
              </div>
              <div
                style={{
                  padding: "6px 12px",
                  background: "white",
                  borderRadius: "8px",
                  border: "1px solid #e2e8f0",
                  boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
                  fontSize: "14px",
                }}
              >
                <span style={{ color: "#64748b", fontWeight: 500 }}>
                  Amount (In A/C):{" "}
                </span>
                <span style={{ fontWeight: 700, color: "#0f172a" }}>
                  ₹{" "}
                  {(
                    packageRate != null && packageRate !== ""
                      ? Number(packageRate)
                      : (inventories
                        ?.filter((item) => !item.suffixCode)
                        ?.reduce(
                          (sum, i) =>
                            sum + (Number(i?.specialRate) || 0),
                          0
                        ) || 0)
                  ).toLocaleString("en-IN")}
                </span>
              </div>
            </div>
          </div>
        )}

        <div
          style={{
            display: "flex",
            justifyContent: "end",
            gap: "1rem",
            marginTop: "1rem",
          }}
        >
          <Button onClick={() => setActiveTab("2")}>Back</Button>

          <Button onClick={() => displayInvs()} type="primary">
            Add Inventories
          </Button>
          {excelActionsEl &&
            createPortal(
              <>
                <Button type="primary" onClick={openExcelImport}>
                  Upload Own Inventory Excel
                </Button>
                <Button type="primary" onClick={openTradingImport}>
                  Upload Trading Excel
                </Button>
              </>,
              excelActionsEl,
            )}
          <input
            ref={excelInputRef}
            type="file"
            accept=".xlsx,.xls,.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,text/csv"
            style={{ display: "none" }}
            onChange={handleExcelFileChange}
          />
          <input
            ref={tradingExcelInputRef}
            type="file"
            accept=".xlsx,.xls,.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,text/csv"
            style={{ display: "none" }}
            onChange={handleTradingFileChange}
          />
          <Button
            type="primary"
            loading={loadingRemovedInvs}
            onClick={() => displayRemovedInvs()}
          >
            Add Removed Inventories
          </Button>
          <Button
            type="primary"
            loading={loadingTradingInvs}
            onClick={() => displayTradingInvs()}
          >
            Add existing Trading inventories
          </Button>
          <Button type="primary" onClick={() => setAddInventoryBoolean(true)}>
            Create new Trading inventory
          </Button>
          {/* <Button type="primary" onClick={showModal}>
            Add Suffix
          </Button> */}
          <Button
            onClick={async () => {
              try {
                setIsSavingBdf(true);
                await handleBDFEdit();
              } finally {
                setIsSavingBdf(false);
              }
            }}
            type="primary"
            disabled={isSavingBdf}
            loading={isSavingBdf}
          >
            Save BDF
          </Button>
        </div>

        {suffixInventories?.length > 0 && (
          <Table
            components={components}
            columns={suffixTableColumns}
            dataSource={suffixInventories}
            style={{ marginTop: "2rem" }}
          />
        )}
      </div>

      <TradingExcelImportModal
        open={tradingImport.open}
        status={tradingImport.status}
        fileName={tradingImport.fileName}
        error={tradingImport.error}
        foundHeaders={tradingImport.foundHeaders}
        info={tradingImport.info}
        plan={tradingImport.plan}
        edits={tradingImport.edits}
        vendors={tradingVendors}
        showMissing={tradingImport.showMissing}
        progress={tradingImport.progress}
        onEdit={setTradingEdit}
        onEditAll={setTradingEditForAll}
        onImport={confirmTradingImport}
        onCancel={closeTradingImport}
        onDownloadTemplate={downloadTradingTemplate}
        onChooseFile={openTradingFilePicker}
      />
      <BdfExcelImportModal
        open={excelImport.open}
        status={excelImport.status}
        fileName={excelImport.fileName}
        error={excelImport.error}
        foundHeaders={excelImport.foundHeaders}
        info={excelImport.info}
        plan={excelImport.plan}
        packageRateActive={Boolean(packageRate)}
        importing={false}
        onImport={confirmExcelImport}
        onCancel={closeExcelImport}
        onDownloadTemplate={downloadExcelTemplate}
        onChooseAnother={openExcelPicker}
      />
      <Modal
        title="Choose Inventories"
        open={openInvs}
        onOk={handleOkOfAllInv}
        onCancel={handleCloseAllInv}
        width={900}
      >
        <Input
          ref={inputRef}
          placeholder="Search Any Field"
          value={searchText}
          onChange={(e) => handleFilterData(e)}
        />
        <div style={{ width: "100%", overflow: "auto", margin: "20px 0px" }}>
          <Table dataSource={allInv} columns={columnsForInvs} rowKey="_id" />
        </div>
      </Modal>

      <Modal
        title={
          inventoryPickerType === "removed"
            ? "Choose Removed Inventories"
            : "Choose Trading Inventories"
        }
        open={openTradingInvs}
        onOk={handleOkOfTradingInv}
        onCancel={handleCloseTradingInv}
        width={900}
      >
        <Input
          placeholder="Search Any Field"
          value={tradingSearchText}
          onChange={(e) => handleTradingFilterData(e)}
        />
        <div style={{ width: "100%", overflow: "auto", margin: "20px 0px" }}>
          <Table
            dataSource={allTradingInv}
            columns={columnsForTradingInvs}
            rowKey="_id"
            loading={loadingTradingInvs}
          />
        </div>
      </Modal>

      <AddSuffixModal
        open={open}
        setOpen={setOpen}
        showModal={showModal}
        handleCancel={handleCancel}
        suffixInventories={suffixInventories}
        setSuffixInventories={setSuffixInventories}
      />

      {/* Add Trading Inventory Modal */}
      <Modal
        open={addInventoryBoolean}
        onCancel={() => {
          setAddInventoryBoolean(false);
          form.resetFields();
          setSelectedImage(null);
          setImageUrl(null);
          setSelectedFiles([]);
          setPreviewURLs([]);
          setFlag(false);
        }}
        width={1000}
        footer={[
          <Button
            key="back"
            onClick={() => {
              setAddInventoryBoolean(false);
              form.resetFields();
              setSelectedImage(null);
              setImageUrl(null);
              setSelectedFiles([]);
              setPreviewURLs([]);
              setFlag(false);
            }}
          >
            Cancel
          </Button>,
        ]}
      >
        <div className="add-inventory-container">
          <div className="add-inventory-form">
            <div className="label-headings">Add Trading Inventory</div>
            <Form
              form={form}
              name="basic"
              onFinish={onFinish}
              initialValues={{ remember: true }}
              layout="vertical"
            >
              {/* First Row */}
              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item
                    label={
                      <span>
                        City <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="city"
                    rules={[
                      { required: true, message: "Please add the city!" },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label={
                      <span>
                        Area <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="area"
                    rules={[
                      { required: true, message: "Please add the Area!" },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label={
                      <span>
                        Media Vehicle <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="mediaType"
                    rules={[
                      {
                        required: true,
                        message: "Please select the media vehicle!",
                      },
                    ]}
                  >
                    <Select placeholder="Please select">
                      <Option value="Gantry">Gantry</Option>
                      <Option value="Unipole">Unipole</Option>
                      <Option value="Hoarding">Hoarding</Option>
                      <Option value="Cantilever">Cantilever</Option>
                      <Option value="LED">LED</Option>
                      <Option value="Kiosk">Kiosk</Option>
                      {/* <Option value="Newspaper">Newspaper</Option>
                      <Option value="Magazine">Magazine</Option> */}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              {/* Second Row */}
              <Row gutter={16}>
                <Col span={16}>
                  <Form.Item
                    label={
                      <span>
                        Location <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="name"
                    rules={[
                      { required: true, message: "Please add the location!" },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label={
                      <span>
                        Media Type/ILLU <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="illu"
                    rules={[
                      {
                        required: true,
                        message: "Please select the media Type!",
                      },
                    ]}
                  >
                    <Select placeholder="Please select">
                      <Option value="FL">FL</Option>
                      <Option value="BL">BL</Option>
                      <Option value="NL">NL</Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <div
                style={{ display: "flex" }}
                className="add-inventory-third-row"
              >
                <div>
                  <div className="add-inventory-image-upload">
                    {imageUrl ? (
                      <img
                        src={selectedImage}
                        style={{
                          width: "200px",
                          minHeight: "200px",
                          objectFit: "cover",
                          border: "2px solid #ccc",
                          borderRadius: "5px",
                          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        }}
                      />
                    ) : (
                      "Upload image here"
                    )}
                    <Button
                      type="primary"
                      shape="circle"
                      icon={<PlusOutlined />}
                      style={{ position: "absolute", top: "80%" }}
                      onClick={handleUpload}
                    />
                    <input
                      type="file"
                      multiple
                      style={{ display: "none" }}
                      className="imageFile"
                      onChange={handleFileChange}
                    />
                  </div>
                </div>
                <div>
                  <div>
                    <Form.Item
                      label={
                        <span>
                          Suffix<span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      name="suffix"
                      rules={[
                        {
                          required: true,
                          message: "Please select the suffix!",
                        },
                      ]}
                    >
                      <Select placeholder="Please select">
                        <Option value="HO">HO</Option>
                        <Option value="PRD">PRD</Option>
                        <Option value="PRN">PRN</Option>
                        <Option value="BR">BR</Option>
                        <Option value="OTH">OTH</Option>
                      </Select>
                    </Form.Item>

                    <Form.Item
                      label={
                        <span>
                          Width <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      name="width"
                      rules={[
                        {
                          required: true,
                          message: "Please input!",
                        },
                        {
                          pattern: /^[0-9]*$/,
                          message: "Please enter numbers only!",
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      label={
                        <span>
                          Height <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      name="height"
                      rules={[
                        {
                          required: true,
                          message: "Please input!",
                        },
                        {
                          pattern: /^[0-9]*$/,
                          message: "Please enter numbers only!",
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </div>
                  {/* <div>
                    <Form.Item label="Code No." name="codeNo">
                      <Input />
                    </Form.Item>

                    <Form.Item label="CAS Code" name="casCode">
                      <Input />
                    </Form.Item>
                  </div> */}
                  <div>
                    <Form.Item
                      label={
                        <span>
                          Vendor <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      name="vendor"
                      rules={[
                        {
                          required: true,
                          message: "Please select the Vendor!",
                        },
                      ]}
                    >
                      <Select
                        placeholder="Please select"
                        showSearch
                        allowClear
                        optionLabelProp="label"
                        filterOption={(input, option) =>
                          option.children[0].props.children
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      >
                        {vendors?.map((vendor) => (
                          <Option
                            key={vendor?.name}
                            value={vendor?.name}
                            label={vendor?.name}
                          >
                            <div style={{ fontWeight: "bold" }}>
                              {vendor?.name}
                            </div>
                            <div style={{ fontSize: "12px", color: "#888" }}>
                              {vendor?.gstNumber
                                ? vendor?.gstNumber
                                : "No GST Number"}
                            </div>
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      label={
                        <span>
                          Rate Per Month <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      name="ratePerMonth"
                      rules={[
                        {
                          required: true,
                          message: "Please input!",
                        },
                        {
                          pattern: /^[0-9]*$/,
                          message: "Please enter numbers only!",
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </div>
                  <div>
                    <Form.Item label={<span>Latitude</span>} name="lat">
                      <Input />
                    </Form.Item>
                    <Form.Item label={<span>Longitude</span>} name="lng">
                      <Input />
                    </Form.Item>
                  </div>
                  <div>
                    <Form.Item
                      label={
                        <span>
                          Buying Cost Per Month<span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      name="PurchaseRate"
                      rules={[
                        {
                          required: true,
                          message: "Please enter buying cost!",
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </div>
                  <div>
                    <Form.Item
                      style={{ marginBottom: "3rem", marginTop: "1rem" }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <Button type="primary" htmlType="submit">
                          Submit
                        </Button>
                      </div>
                    </Form.Item>
                  </div>
                </div>
              </div>
              <Trade
                setInventories={setInventories}
                inventories={inventories}
                setAddInventoryBoolean={setAddInventoryBoolean}
              />
            </Form>
          </div>
        </div>
      </Modal>
    </>
  );
};
